webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_actualizarregistro_js__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_281ec7c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Actualizarregistro_vue__ = __webpack_require__(93);
function injectStyle (ssrContext) {
  __webpack_require__(92)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_actualizarregistro_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_281ec7c4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Actualizarregistro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'principal',
  components: {},
  data: function data() {
    return {};
  },
  methods: {
    iniciarsesion: function iniciarsesion() {
      this.$router.push('/login');
    },
    inicio: function inicio() {
      this.$router.push('/');
    },
    irapedidos: function irapedidos() {
      this.$router.push('/pedidos');
    },
    irabiblioteca: function irabiblioteca() {
      this.$router.push('/biblioteca');
    }
  },
  computed: {
    islogin: function islogin() {
      return this.$store.getters.islogin;
    },
    iscarpintero: function iscarpintero() {
      return this.$store.getters.escarpintero;
    },
    nombreusuario: function nombreusuario() {
      return this.$store.getters.nombreusuario;
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Auth',
  components: {},
  data: function data() {
    return {
      ip: '', errores: []
    };
  },

  props: ['usr', 'auth'],
  created: function created() {
    this.enviarloginapi();
  },

  methods: {
    enviarloginapi: function enviarloginapi() {
      var _this = this;

      var empresa = this.$store.getters.url_empresa;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/auth/', {
        params: {
          "auth": this.auth, "id": this.usr, "empresa": empresa
        }
      }).then(function (response) {
        return _this.pasologinapi(response);
      }, function (response) {
        return _this.errorloginapi(response);
      }).catch(function (response) {
        return _this.errorloginapi(response);
      });
    },

    pasologinapi: function pasologinapi(respuesta) {
      if (respuesta.data.estado === 1 && respuesta.data.credenciales) {
        this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales);
        this.$store.dispatch('SET_EMPRESAREFERIDA', respuesta.data.empresareferida);
        this.$router.push('/listador');
      } else {
        this.errorloginapi(respuesta);
      }
    },
    errorloginapi: function errorloginapi(respuesta) {
      console.log(respuesta);
      if (respuesta.data.estado && respuesta.data.estado != 1) {
        this.errores = [];
        this.errores.push("Error en los datos enviados");
      }
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Enviarbiblioteca',
  components: {},
  data: function data() {
    return {
      errores: [], pedido: []
    };
  },

  props: ['pedidolocal'],
  mounted: function mounted() {
    this.cargarpedido();
  },

  methods: {
    listapedidos: function listapedidos(lista) {
      return _.orderBy(lista, ['id'], ['desc']);
    },
    volveratras: function volveratras() {
      this.$router.push('/listador');
    },
    enviarbiblioteca: function enviarbiblioteca(categoria, pedido) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/enviarbiblioteca', {
        "categoria": categoria, "pedido": pedido, "cred": this.$store.getters.credactual, '4665': this.$store.getters.idactual
      }).then(function (response) {
        return _this.pasoenviar(response);
      }, function (response) {
        return _this.errorenviar(response);
      }).catch(function (response) {
        return _this.errorenviar(response);
      });
    },
    pasoenviar: function pasoenviar(response) {
      if (response.data.estado === 1) {
        var url = '/categoria/' + response.data.categoria.slug + '/1';
        this.$router.push(url);
      }
    },
    errorenviar: function errorenviar(response) {},
    cargarpedido: function cargarpedido() {
      var conditionArr = [parseInt(this.pedidolocal)];
      var result = _.filter(this.$store.getters.pedidos, function (v) {
        return _.includes(conditionArr, v.id);
      });
      this.pedido = result[0];
      return result;
    },
    cargarcategorias: function cargarcategorias() {
      var _this2 = this;

      if (this.$store.getters.islogin === true) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/biblioteca/', {
          params: {
            'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
          }
        }).then(function (response) {
          return _this2.procesarcategorias(response);
        }, function (response) {
          return _this2.errorprocesarcategorias(response);
        }).catch(function (response) {
          return _this2.errorprocesarcategorias(response);
        });
      } else {
        errorprocesarcategorias('notcred');
      }
    },
    procesarcategorias: function procesarcategorias(response) {
      if (response.data.estado === 1) {
        this.$store.dispatch('SET_CATEGORIAS', response.data.categorias);
      }
    },
    errorprocesarcategorias: function errorprocesarcategorias(response) {}
  },
  computed: {
    categorias: function categorias() {
      var act = _.orderBy(this.$store.getters.categorias, ['id'], ['desc']);
      if (_.isEmpty(act)) {
        console.log('vacio');
        this.cargarcategorias();
        return null;
      }
      return act;
    },
    nombrematerial: function nombrematerial() {
      if (this.pedido.material == 2) {
        return 'Melamínico Otro MDF 18mm 2600x1830';
      } else if (this.pedido.material == 3) {
        return 'Melamínico Otro MDF 18mm 2750x1830';
      } else {
        return 'Melamínico Blanco MDF 18mm 2600x1830';
      }
    },
    colorplaca: function colorplaca() {
      if (this.pedido.material >= 2) {
        return 'Color: ' + this.pedido.colorplaca;
      }
    },
    colorcanto: function colorcanto() {
      if (this.pedido.material >= 2) {
        return 'Color: ' + this.pedido.colorcanto;
      }
    },
    nombrecanto: function nombrecanto() {
      if (this.pedido.material == 1) {
        return 'ABS Blanco';
      } else {
        return 'ABS Otro';
      }
    }
  },
  watch: {}
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Actualizarregistro__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Biblioteca',
  components: { Actualizar: __WEBPACK_IMPORTED_MODULE_1__Actualizarregistro__["a" /* default */] },
  data: function data() {
    return {
      errores: [], nombrecategoria: ''
    };
  },
  created: function created() {
    if (!this.$store.getters.islogin) {
      this.$router.push('/login');
    } else {
      this.consultarpedidosapi();
    }
  },

  methods: {
    listapedidos: function listapedidos(lista) {
      return _.orderBy(lista, ['id'], ['desc']);
    },
    consultarpedidosapi: function consultarpedidosapi() {
      var _this = this;

      if (this.$store.getters.islogin === true) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/biblioteca/', {
          params: {
            'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
          }
        }).then(function (response) {
          return _this.procesarbiblioteca(response);
        }, function (response) {
          return _this.errorprocesarpedidos(response);
        }).catch(function (response) {
          return _this.errorprocesarpedidos(response);
        });
      } else {
        errorprocesarpedidos('notcred');
      }
    },
    procesarbiblioteca: function procesarbiblioteca(response) {
      if (response.data.estado === 1) {
        this.$store.dispatch('SET_CATEGORIAS', response.data.categorias);
      }
    },
    errorprocesarpedidos: function errorprocesarpedidos(response) {
      console.log(response);
    },
    volveratras: function volveratras() {
      this.$router.push('/listador');
    },
    ircategoria: function ircategoria(id) {
      this.$router.push('/categoria/' + id);
    },
    crearcategoria: function crearcategoria() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/nuevacategoria', {
        "categoria": this.nombrecategoria, "cred": this.$store.getters.credactual, '4665': this.$store.getters.idactual
      }).then(function (response) {
        return _this2.pasocrear(response);
      }, function (response) {
        return _this2.errorcrear(response);
      }).catch(function (response) {
        return _this2.errorcrear(response);
      });
    },
    pasocrear: function pasocrear(response) {
      if (response.data.estado === 1) {
        this.$store.dispatch('SET_CATEGORIAS', response.data.categorias);
        this.nombrecategoria = '';
      }
    },
    errorcrear: function errorcrear(response) {}
  },
  computed: {
    categorias: function categorias() {
      return _.orderBy(this.$store.getters.categorias, ['id'], ['desc']);
    }
  },
  watch: {}
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Actualizar',
  data: function data() {
    return {
      avisos: [], datosperfil: ''
    };
  },
  mounted: function mounted() {
    if (this.$store.getters.pedirdatos === true) {
      this.alertapedirdatos();
    }
  },

  methods: {
    alertapedirdatos: function alertapedirdatos() {
      var _this = this;

      this.datosperfil = swal({
        title: 'Actualiza tu Perfil',
        html: '<label for="placa">Mail:</label><input placeholder="mail@gmail.com" id="swal-input1" class="swal2-input" type="email">' + '<label for="placa">Dirección:</label><input placeholder="Calle + Nro" id="swal-input2" class="swal2-input">',
        focusConfirm: false,
        confirmButtonText: 'Actualizar',
        preConfirm: function preConfirm(valor) {
          if (document.getElementById('swal-input1').value != '' && document.getElementById('swal-input2').value != '') {
            return [document.getElementById('swal-input1').value, document.getElementById('swal-input2').value];
          } else {
            return false;
          }
        }
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(_this.$apibase + 'gen/actualizarregistro', {
            "mail": result.value[0], "direccion": result.value[1], "cred": _this.$store.getters.credactual, '4665': _this.$store.getters.idactual
          }).then(function (response) {
            return _this.pasoactregistro(response);
          }, function (response) {
            return _this.erroractregistro(response);
          }).catch(function (response) {
            return _this.erroractregistro(response);
          });
        }
      });
    },
    pasoactregistro: function pasoactregistro(response) {
      if (response.data.estado === 1) {
        this.$store.dispatch('SET_CREDENCIALES', response.data.credenciales);
        if (response.data.credenciales) {}
      } else {
        this.erroractregistro(response);
      }
    },
    erroractregistro: function erroractregistro(response) {}
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'completo',
  components: {},
  data: function data() {
    return {
      errores: [], carpeta: 0, biblioteca: 0, alertapedidoguardado: 0, pedido: '', sologuardar: ''
    };
  },

  props: ['idnuevo', 'guardar'],
  mounted: function mounted() {
    if (this.guardar === "1") {
      this.alertapedidoguardado = 1;
      this.sologuardar = 1;
      this.consultarpedidoapi();
    }
  },
  created: function created() {
    if (this.guardar === "1") {
      this.alertapedidoguardado = 1;
      this.sologuardar = 1;
      this.consultarpedidoapi();
    }
  },

  methods: {
    consultarpedidoapi: function consultarpedidoapi() {
      var _this = this;

      if (this.$store.getters.islogin === true) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/verpedido/', {
          params: {
            'id': this.idnuevo, 'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
          }
        }).then(function (response) {
          return _this.procesarpedido(response);
        }, function (response) {
          return _this.errorprocesarpedido(response);
        }).catch(function (response) {
          return _this.errorprocesarpedido(response);
        });
      } else {
        errorprocesarpedido('notcred');
      }
    },

    procesarpedido: function procesarpedido(response) {
      this.pedido = response.data.pedido;
    },
    errorprocesarpedido: function errorprocesarpedido(response) {},
    loginmuebles: function loginmuebles() {
      window.location = this.$store.getters.urlsalida;
    },
    volveratras: function volveratras(event) {
      this.$router.push('/listador');
    },
    verpedido: function verpedido() {
      this.$router.push('/pedidos');
    },
    consultarbiblioteca: function consultarbiblioteca() {
      var _this2 = this;

      if (this.$store.getters.islogin === true) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/biblioteca/', {
          params: {
            'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
          }
        }).then(function (response) {
          return _this2.procesarbiblioteca(response);
        }, function (response) {
          return _this2.errorprocesarpedidos(response);
        }).catch(function (response) {
          return _this2.errorprocesarpedidos(response);
        });
      } else {
        errorprocesarpedidos('notcred');
      }
    },
    procesarbiblioteca: function procesarbiblioteca(response) {
      if (response.data.estado === 1) {
        this.$store.dispatch('SET_CATEGORIAS', response.data.categorias);
      }
    },
    errorprocesarpedidos: function errorprocesarpedidos(response) {},

    guardarbiblioteca: function guardarbiblioteca() {
      var _this3 = this;

      if (this.verificarformb && this.$store.getters.escarpintero === true) {

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/enviarbiblioteca', {
          "categoria": this.carpeta, "pedido": this.idnuevo, "cred": this.$store.getters.credactual, '4665': this.$store.getters.idactual
        }).then(function (response) {
          return _this3.pasoguardar(response);
        }, function (response) {
          return _this3.errorguardar(response);
        }).catch(function (response) {
          return _this3.errorguardar(response);
        });
      }
    },
    pasoguardar: function pasoguardar(response) {
      if (response.data.estado === 1) {
        this.alertapedidoguardado = 1;
        this.carpeta = 0;
        this.biblioteca = 0;
        if (response.data.pedidoviejo.idproveedor === 1) {
          this.sologuardar = 1;
          this.pedido = response.data.pedidoviejo;
        }
      }
    },
    errorguardar: function errorguardar(reponse) {},

    descargararchivo: function descargararchivo() {},
    iralarchivo: function iralarchivo(archivo) {
      window.open(archivo, '_blank');
    }
  },
  computed: {
    urldescarga: function urldescarga() {
      return this.pedido.urlarchivo;
    },
    verificarformb: function verificarformb(event) {
      this.errores = [];

      if (this.biblioteca < '1') {
        this.errores.push("Seleccione si desea guardar");
      }
      if (this.biblioteca === '1' && this.carpeta <= 0) {
        this.errores.push("Seleccione una Carpeta");
      }

      if (!this.errores.length) {
        return true;
      } else {
        return false;
      }
    },
    categoriasbiblioteca: function categoriasbiblioteca() {
      if (this.biblioteca === '1') {
        if (this.$store.getters.categorias[1] !== undefined) {
          return _.orderBy(this.$store.getters.categorias, ['id'], ['desc']);
        } else {
          this.consultarbiblioteca();
          return _.orderBy(this.$store.getters.categorias, ['id'], ['desc']);
        }
      }
    }
  },
  watch: {}
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Categoria',
  components: {},
  data: function data() {
    return {
      errores: [], pedidos: '', categoria: '', alerta: 0
    };
  },

  props: ['slug', 'msg'],
  created: function created() {
    this.consultarpedidosapi();
    if (this.msg > 0) {
      this.alerta = 1;
    }
  },

  methods: {
    listapedidos: function listapedidos(lista) {
      return _.orderBy(lista, ['id'], ['desc']);
    },
    consultarpedidosapi: function consultarpedidosapi() {
      var _this = this;

      if (this.$store.getters.islogin === true) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/categoria/', {
          params: {
            'cat': this.slug, 'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
          }
        }).then(function (response) {
          return _this.pasoconsultar(response);
        }, function (response) {
          return _this.errorconsultar(response);
        }).catch(function (response) {
          return _this.errorconsultar(response);
        });
      } else {
        errorconsultar('notcred');
      }
    },
    pasoconsultar: function pasoconsultar(response) {
      if (response.data.estado === 1) {
        this.pedidos = response.data.pedidos;
        this.categoria = response.data.categoria;
      } else if (response.data.estado === 8) {
        this.categoria = response.data.categoria;
      }
    },
    errorconsultar: function errorconsultar(response) {
      console.log(response);
    },
    volveratras: function volveratras() {
      this.$router.push('/biblioteca');
    },
    nuevopedido: function nuevopedido() {
      this.$router.push('/listador');
    },
    irpedido: function irpedido(id) {
      this.$router.push('/pedido/' + id);
    },
    eliminarpedido: function eliminarpedido(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/eliminarpedido', {
        "slugcategoria": this.categoria.slug, "pedido": id, "cred": this.$store.getters.credactual, '4665': this.$store.getters.idactual
      }).then(function (response) {
        return _this2.pasoeliminar(response);
      }, function (response) {
        return _this2.erroreliminar(response);
      }).catch(function (response) {
        return _this2.erroreliminar(response);
      });
    },
    pasoeliminar: function pasoeliminar(response) {
      if (response.data.estado === 1) {
        this.$store.dispatch('SET_PEDIDOS', response.data.pedidos);
        this.pedidos = response.data.pedidos_categoria;
      }
    },
    erroreliminar: function erroreliminar(response) {}
  },
  computed: {
    pedidos: function pedidos() {
      return _.orderBy(this.pedidos, ['id'], ['desc']);
    },
    nombrecategoria: function nombrecategoria() {
      return this.categoria.nombre;
    }
  },
  watch: {}
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Confirmacionpedido',
  components: {},
  data: function data() {
    return {
      errores: [], cargado: false
    };
  },

  props: ['usr', 'auth', 'pedido'],
  created: function created() {
    this.enviarloginapi();
  },

  methods: {
    enviarloginapi: function enviarloginapi() {
      var _this = this;

      var empresa = this.$store.getters.url_empresa;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/confirmacionpedido/', {
        params: {
          "auth": this.auth, "id": this.usr, "pedido": this.pedido
        }
      }).then(function (response) {
        return _this.pasologinapi(response);
      }, function (response) {
        return _this.errorloginapi(response);
      }).catch(function (response) {
        return _this.errorloginapi(response);
      });
    },

    pasologinapi: function pasologinapi(respuesta) {
      if (respuesta.data.estado === 1 && respuesta.data.credenciales) {
        this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales);
        if (respuesta.data.pedido) {
          this.cargado = true;
        }
      } else {
        this.errorloginapi(respuesta);
      }
    },
    errorloginapi: function errorloginapi(respuesta) {
      console.log(respuesta);
      if (respuesta.data.estado && respuesta.data.estado != 1) {
        this.errores = [];
        this.errores.push("Error en los datos enviados");
      }
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'enviarpedido',
  components: {},
  data: function data() {
    return {
      ip: '', lugar: 0, proveedores: [], direccion_barraca: '',
      errores: [], nombre: '', telefono: '', mail: '', direccion: ''
    };
  },
  beforeCreate: function beforeCreate() {
    if (this.$store.getters.cantidadpiezas < 1) {
      this.$router.push('/listador');
    }
  },
  mounted: function mounted() {
    this.consultarproveedores();
  },

  methods: {
    consultarproveedores: function consultarproveedores() {
      var _this = this;

      if (this.$store.getters.empresareferida === 141 || this.$store.getters.empresareferida === 151) {
        this.proveedores = this.$store.getters.datosempresareferida;
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/proveedores/', {
          params: {
            'cliente': this.$store.getters.idactual, 'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
          }
        }).then(function (response) {
          return _this.pasoproveedoresapi(response);
        }, function (response) {
          return _this.errorproveedoresapi(response);
        }).catch(function (response) {
          return _this.errorproveedoresapi(response);
        });
      }
    },
    pasoproveedoresapi: function pasoproveedoresapi(response) {
      if (response.data.estado === 1) {
        this.proveedores = response.data.proveedores;
      }
    },
    errorproveedoresapi: function errorproveedoresapi(response) {},
    cargarpedido: function cargarpedido(event) {
      if (event) {
        event.preventDefault();
        var pedido = [];
        var cliente = [];
        if (this.$store.getters.islogin === true) {
          cliente.push({ 'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual });
        } else {
          cliente.push({ 'nombre': this.nombre, 'telefono': this.telefono, 'mail': this.mail, 'direccion': this.direccion });
        }

        pedido.push({ 'cliente': cliente });
        pedido.push({ 'piezas': this.$store.getters.piezas });

        if (this.$store.getters.escarpintero === true) {
          pedido.push({ 'lugar': parseInt(this.lugar) });
          if (this.verificarenviobarraca === true) {
            pedido.push({ 'direccion_barraca': this.direccion_barraca });
          }
          if (this.$store.getters.color_canto === '') {
            this.$store.dispatch('CAMBIAR_COLOR_CANTO', 'Blanco');
          }
          if (this.$store.getters.color_placa === '') {
            this.$store.dispatch('CAMBIAR_COLOR', 'Blanco');
          }
          pedido.push({ 'color_canto': this.$store.getters.color_canto });
          pedido.push({ 'color_placa': this.$store.getters.color_placa });
        }
        pedido.push({ 'descripcion': this.$store.getters.descripcion });
        pedido.push({ 'placa': this.$store.getters.placa });
        pedido.push({ 'canto': this.$store.getters.canto });
        pedido.push({ 'mt2': this.$store.getters.totalmt2 });
        pedido.push({ 'mtl045': this.$store.getters.totalmtl045 });
        pedido.push({ 'mtl2': this.$store.getters.totalmtl2 });
        pedido.push({ 'mtcorte': this.$store.getters.totalmtscorte });

        this.enviarpedidoapi(pedido);
      }
    },
    enviarpedidoapi: function enviarpedidoapi(pedido) {
      var _this2 = this;

      var empresa = this.$store.getters.url_empresa;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/pedido', {
        "pedido": pedido, "cred": this.$store.getters.credactual, "empresa": empresa
      }).then(function (response) {
        return _this2.pasopedidoapi(response);
      }, function (response) {
        return _this2.errorpedidoapi(response);
      }).catch(function (response) {
        return _this2.errorpedidoapi(response);
      });
    },
    volveratras: function volveratras(event) {
      this.$router.push('/listador');
    },
    pasaracompleto: function pasaracompleto(id) {
      var link = '/pedidocompleto/' + id;
      if (parseInt(this.lugar) === 1) {
        link = link + '/1';
      }
      this.$router.push(link);
    },
    pasopedidoapi: function pasopedidoapi(respuesta) {
      if (respuesta.data.pedido.estado === 1) {
        if (respuesta.data.credenciales) {
          this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales);
        }
        if (respuesta.data.pedido.url) {
          this.$store.dispatch('SET_URL_VER', respuesta.data.pedido.url);
        }
        this.$store.dispatch('REINICIAR_PEDIDO');
        this.pasaracompleto(respuesta.data.pedido.idnuevo);
      } else {
        console.log(' no ingreso el pedido');
      }
    },
    errorpedidoapi: function errorpedidoapi(respuesta) {
      console.log(event);
      console.log('error');
    },
    verificartelefono: function verificartelefono(actual) {
      var input = actual.replace(/[\D\s\._\-]+/g, "");
      var re = "/(\d{3})(\d{3})(\d{3})/g";
      var nuevo = input.replace(re, "$1$2$3");
      var codigo = actual.replace(re, "$1");
      return true;
    },
    validEmail: function validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  computed: {
    datosvalidos: function datosvalidos() {},
    verificarenviobarraca: function verificarenviobarraca() {
      if (this.lugar > 1 && this.lugar !== this.$store.getters.idactual) {
        return true;
      }
      return false;
    },
    verificarformlogin: function verificarformlogin(event) {
      this.errores = [];
      if (this.lugar < 1) {
        this.errores.push("Debe seleccionar un lugar");
      }
      if (this.biblioteca < 1) {
        this.errores.push("Seleccione si desea guardar");
      }
      if (this.biblioteca === '1' && this.carpeta <= 0) {
        this.errores.push("Seleccione una Carpeta");
      }
      if (this.verificarenviobarraca === true && this.direccion_barraca === '') {
        this.errores.push("Indique una dirección para envío");
      }
      if (!this.errores.length) {
        return true;
      } else {
        return false;
      }
    },
    verificarform: function verificarform(event) {
      this.errores = [];
      if (this.$store.getters.islogin !== true) {
        if (this.nombre === '') {
          this.errores.push("Indique su Nombre");
        }
        if (this.direccion === '') {
          this.errores.push("Indique una Dirección para envío");
        }
        if (!this.validEmail(this.mail)) {
          this.errores.push("Indique un Mail válido");
        }
      }
      if (!this.errores.length) {
        return true;
      } else {
        return false;
      }
    },
    clasenombre: function clasenombre() {
      if (this.nombre === '') return 'error-input';
    },
    clasetelefono: function clasetelefono() {
      if (this.telefono === '') return 'error-input';
    },
    clasemail: function clasemail() {
      if (!this.validEmail(this.mail)) return 'error-input';
    },
    clasedireccion: function clasedireccion() {
      if (this.direccion === '') return 'error-input';
    }
  },
  watch: {
    respuestapedidoapi: function respuestapedidoapi(response) {
      if (response.data.pedido.status === 1) {
        this.$router.push('/pedidocompleto');
      } else {
        alert('Error al procesar su pedido, verifique la informacion enviada');
      }
    }
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Inicio',
  components: {},
  data: function data() {
    return {
      errores: []
    };
  },
  created: function created() {
    this.verificarcredenciales();
  },

  methods: {
    verificarcredenciales: function verificarcredenciales() {
      if (this.login === true) {
        this.$router.push('/listador');
      } else {
        this.$router.push('/login');
      }
    },
    irregistro: function irregistro() {
      this.$router.push('/login');
    },
    irlistador: function irlistador() {
      this.$router.push('/listador');
    }
  },
  computed: {
    cred: function cred() {
      return this.$store.getters.credactual;
    },
    login: function login() {
      return this.$store.getters.islogin;
    }
  },
  watch: {}
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Informacion',
  components: {},
  data: function data() {
    return {
      nombre: '', celular: '', consulta: '', respuestaconsulta: '',
      errores: [], avisos: [], cargando: '', cargandoconsulta: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    atras: function atras() {
      this.$router.push('/login');
    },

    registrarconsulta: function registrarconsulta(event) {
      if (this.verificarformreg() === true) {
        this.cargandoconsulta = 'Cargando....';
        event.preventDefault();
        event.stopPropagation();
        this.enviarconsultaapi();
      }
    },
    verificarformreg: function verificarformreg(event) {
      this.avisos = [];
      if (this.nombre === '') {
        this.avisos.push("Indique su Nombre");
      }
      if (this.celular === '') {
        this.avisos.push("Indique su Celular");
      } else {
        if (this.verificarcelular(this.celular) === false) {
          this.avisos.push("Número de Celular no válido");
        }
      }
      if (this.consulta === '') {
        this.avisos.push("Indique su consulta");
      }

      if (!this.avisos.length) {
        return true;
      } else {
        return false;
      }
    },
    verificarcelular: function verificarcelular(actual) {
      var re = /(\d{3})(\d{3})(\d{3})/g;
      var nuevo = actual.replace(re, "$1$2$3");
      var codigo = actual.replace(re, "$1");

      if (codigo <= 99) {
        switch (codigo) {
          case '091':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '092':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '093':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '094':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '095':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '096':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '097':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '098':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '099':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    enviarconsultaapi: function enviarconsultaapi() {
      var _this = this;

      var carpintero = [];
      carpintero.push({ 'nombre': this.nombre, 'tel': this.celular, 'consulta': this.consulta });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/consultar/', {
        "usuario": carpintero, 2006: 1
      }).then(function (response) {
        return _this.pasoapi(response);
      }, function (response) {
        return _this.errorapi(response);
      }).catch(function (response) {
        return _this.errorapi(response);
      });
    },

    pasoapi: function pasoapi(respuesta) {
      if (respuesta.data.estado === 1) {
        this.respuestaconsulta = 1;
      } else {
        this.errorapi(respuesta);
      }
    },
    errorapi: function errorapi(respuesta) {
      if (respuesta.data.estado && respuesta.data.estado != 1) {
        this.avisos = [];
        this.avisos.push("Error en los datos enviados");
      }
      this.cargando = '';
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Cantostodos__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Actualizarregistro__ = __webpack_require__(11);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'listador',
  components: {
    SvgCantos: __WEBPACK_IMPORTED_MODULE_1__Cantostodos__["a" /* default */], Actualizar: __WEBPACK_IMPORTED_MODULE_2__Actualizarregistro__["a" /* default */]
  },
  data: function data() {
    return {
      cantidad: '', largo: '', ancho: '', detalle: '', giro: 1, alerta: 0
    };
  },

  props: ['msg'],
  created: function created() {
    if (this.msg > 0) {
      this.buscarmensaje();
    }
  },

  methods: {
    buscarmensaje: function buscarmensaje() {
      this.alerta = this.msg;
    },

    respuestaalerta: function respuestaalerta(response) {
      if (response.data.estado === 1) {
        alerta.push({ 'tipo': response.data.alerta.tipo, 'mensaje': response.data.alerta.mensaje });
      } else {
        erroralertaapi(response);
      }
    },
    erroralertaapi: function erroralertaapi(response) {},
    procesarpieza: function procesarpieza(event) {
      if (this.$store.getters.piezavalida == 1) {
        this.$store.dispatch('PROCESAR_PIEZA');
        this.vaciarpieza();
      } else {
        console.log('no valida');
      }
    },
    vaciarpieza: function vaciarpieza(event) {
      this.cantidad = '';
      this.largo = '';
      this.ancho = '';
      this.detalle = '';
      this.$store.dispatch('VACIAR_PIEZA');
      document.getElementById("cantidad").focus();
    },
    vaciarpedido: function vaciarpedido(event) {
      this.vaciarpieza();
      this.$store.dispatch('VACIAR_PEDIDO');
    },
    eliminarpieza: function eliminarpieza(id) {
      this.$store.dispatch('ELIMINAR_PIEZA', id);
    },
    colorescanto1: function colorescanto1(canto) {
      if (canto === 1) {
        return 'canto1azul';
      } else if (canto === 2) {
        return 'canto1rojo';
      } else {
        return 'canto1gris';
      }
    },
    colorescanto2: function colorescanto2(canto) {
      if (canto === 1) {
        return 'canto2azul';
      } else if (canto === 2) {
        return 'canto2rojo';
      } else {
        return 'canto2gris';
      }
    },
    colorescanto3: function colorescanto3(canto) {
      if (canto === 1) {
        return 'canto3azul';
      } else if (canto === 2) {
        return 'canto3rojo';
      } else {
        return 'canto3gris';
      }
    },
    colorescanto4: function colorescanto4(canto) {
      if (canto === 1) {
        return 'canto4azul';
      } else if (canto === 2) {
        return 'canto4rojo';
      } else {
        return 'canto4gris';
      }
    },
    enviarlista: function enviarlista() {
      this.$router.push('/procesarpedido');
    },
    listadepiezas: function listadepiezas(lista) {
      return _.orderBy(lista, ['id'], ['desc']);
    },

    verificardetalle: function verificardetalle(input) {
      var re = /([\/\-\-\:\+\"\'\%\&\=\?\*\.\_])/g;
      return input.replace(re, "");
    }
  },
  computed: {
    alertaspendientes: function alertaspendientes() {
      if (this.alerta > 0) {
        return this.alerta;
      } else {
        return false;
      }
    },
    totalmts2: function totalmts2() {
      return this.$store.getters.totalmt2;
    },
    totalmts2usd: function totalmts2usd() {
      return this.$store.getters.totalmt2usd;
    },
    totalmtl045: function totalmtl045() {
      return this.$store.getters.totalmtl045;
    },
    totalmtl045usd: function totalmtl045usd() {
      return this.$store.getters.totalmtl045usd;
    },
    totalmtl2: function totalmtl2() {
      return this.$store.getters.totalmtl2;
    },
    totalmtl2usd: function totalmtl2usd() {
      return this.$store.getters.totalmtl2usd;
    },
    totalcorte: function totalcorte() {
      return this.totalmts2usd + this.totalmtl045usd + this.totalmtl2usd;
    },
    totalmtscorte: function totalmtscorte() {
      return this.$store.getters.totalmtscorte;
    },
    clasecantidad: function clasecantidad() {
      if (this.cantidad > 0 && this.cantidad < 100) {
        return 'normal-input';
      } else {
        return 'error-input';
      }
    },
    claselargo: function claselargo() {
      if (this.largo >= 50 && this.largo <= this.$store.getters.max_largo) {
        return 'normal-input';
      } else {
        return 'error-input';
      }
    },
    claseancho: function claseancho() {
      if (this.ancho >= 50 && this.ancho <= this.$store.getters.max_ancho) {
        return 'normal-input';
      } else {
        return 'error-input';
      }
    },
    clasecolor_canto: function clasecolor_canto() {
      if (this.$store.getters.canto > 1 && this.$store.getters.color_canto !== '') {
        return 'normal-input';
      }
      return 'error-input';
    },
    clasecolor_placa: function clasecolor_placa() {
      if (this.$store.getters.placa !== 0 && this.$store.getters.color_placa !== '') {
        return 'normal-input';
      }
      return 'error-input';
    },
    piezavalida: function piezavalida() {
      return this.$store.getters.piezavalida;
    },
    piezas: function piezas() {
      return this.$store.getters.piezas;
    },
    piezascantidad: function piezascantidad() {
      return this.$store.getters.cantidadpiezas;
    },
    clasedescripcion: function clasedescripcion() {
      if (this.$store.getters.descripcionproyecto === '') {
        return 'error-input';
      } else {
        return 'normal-input';
      }
    },
    pedidovalido: function pedidovalido() {
      if (this.$store.getters.descripcionproyecto !== '' && this.$store.getters.cantidadpiezas > 0) {
        if (this.$store.getters.placa !== '0' && this.$store.getters.color_placa !== '') {
          return true;
        }
      }
      return false;
    },

    descripcionproyecto: {
      get: function get() {
        return this.$store.getters.descripcionproyecto;
      },
      set: function set(value) {
        this.$store.dispatch('CAMBIAR_DESCRIPCION', value);
      }
    },
    deshabilitarplaca: function deshabilitarplaca() {
      if (this.$store.getters.placa > 0) {
        return 1;
      }
      return 0;
    },
    deshabilitacanto: function deshabilitacanto() {
      if (this.$store.getters.canto > 1) {
        return 1;
      } else {
        return 0;
      }
    },

    placa: {
      get: function get() {
        return this.$store.getters.placa;
      },
      set: function set(value) {
        this.$store.dispatch('CAMBIAR_PLACA', parseInt(value));
        if (value > 1) {
          this.giro = 0;
        }
      }
    },
    canto: {
      get: function get() {
        return this.$store.getters.canto;
      },
      set: function set(value) {
        this.$store.dispatch('CAMBIAR_CANTOT', value);
      }
    },
    color_placa: {
      get: function get() {
        return this.$store.getters.color_placa;
      },
      set: function set(value) {
        this.$store.dispatch('CAMBIAR_COLOR', value);
      }
    },
    color_canto: {
      get: function get() {
        return this.$store.getters.color_canto;
      },
      set: function set(value) {
        this.$store.dispatch('CAMBIAR_COLOR_CANTO', value);
      }
    }
  },
  watch: {
    cantidad: function cantidad(nuevo) {
      if (nuevo > 0 && nuevo < 100) {
        this.$store.dispatch('CAMBIAR_CANTIDAD', nuevo);
      } else {
        this.$store.dispatch('CAMBIAR_CANTIDAD', 0);
      }
    },
    largo: function largo(nuevo) {
      if (nuevo >= 50 && nuevo <= this.$store.getters.max_largo) {
        this.$store.dispatch('CAMBIAR_LARGO', nuevo);
      } else {
        this.$store.dispatch('CAMBIAR_LARGO', 0);
      }
    },
    ancho: function ancho(nuevo) {
      if (nuevo >= 50 && nuevo <= this.$store.getters.max_ancho) {
        this.$store.dispatch('CAMBIAR_ANCHO', nuevo);
      } else {
        this.$store.dispatch('CAMBIAR_ANCHO', 0);
      }
    },
    detalle: function detalle(nuevo) {
      var cambiado = this.verificardetalle(nuevo);
      this.$store.dispatch('CAMBIAR_DETALLE', cambiado);
      this.detalle = cambiado;
    },
    giro: function giro(nuevo) {
      this.$store.dispatch('CAMBIAR_GIRO', nuevo);
    }
  }
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Canto1_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Canto2_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Canto3_vue__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Canto4_vue__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Giro_vue__ = __webpack_require__(129);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'svg-button',
  components: { Canto1: __WEBPACK_IMPORTED_MODULE_0__Canto1_vue__["a" /* default */], Canto2: __WEBPACK_IMPORTED_MODULE_1__Canto2_vue__["a" /* default */], Canto3: __WEBPACK_IMPORTED_MODULE_2__Canto3_vue__["a" /* default */], Canto4: __WEBPACK_IMPORTED_MODULE_3__Canto4_vue__["a" /* default */], Giro: __WEBPACK_IMPORTED_MODULE_4__Giro_vue__["a" /* default */] },
  data: function data() {
    return {
      isActive: false
    };
  },

  computed: {
    clasecanto1: function clasecanto1() {
      if (this.$store.getters.estadocanto1 === 1) {
        return 'fillazul';
      } else if (this.$store.getters.estadocanto1 === 2) {
        return 'fillrojo';
      } else {
        return 'fillgris';
      }
    },
    clasecanto2: function clasecanto2() {
      if (this.$store.getters.estadocanto2 === 1) {
        return 'fillazul';
      } else if (this.$store.getters.estadocanto2 === 2) {
        return 'fillrojo';
      } else {
        return 'fillgris';
      }
    },
    clasecanto3: function clasecanto3() {
      if (this.$store.getters.estadocanto3 === 1) {
        return 'fillazul';
      } else if (this.$store.getters.estadocanto3 === 2) {
        return 'fillrojo';
      } else {
        return 'fillgris';
      }
    },
    clasecanto4: function clasecanto4() {
      if (this.$store.getters.estadocanto4 === 1) {
        return 'fillazul';
      } else if (this.$store.getters.estadocanto4 === 2) {
        return 'fillrojo';
      } else {
        return 'fillgris';
      }
    },

    getcanto1: function getcanto1() {
      return this.$store.getters.estadocanto1;
    },
    getcanto2: function getcanto2() {
      return this.$store.getters.estadocanto2;
    },
    getcanto3: function getcanto3() {
      return this.$store.getters.estadocanto3;
    },
    getcanto4: function getcanto4() {
      return this.$store.getters.estadocanto4;
    },
    getgiro: function getgiro() {
      return this.$store.getters.giro;
    }
  },
  methods: {
    cambiar_canto: function cambiar_canto(data) {
      this.$store.dispatch('CAMBIAR_CANTO', data);
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'canto1',
  props: { valor: Number },
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'canto2',
  props: { valor: Number },
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'canto3',
  props: { valor: Number },
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'canto4',
  props: { valor: Number },
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'giro',
  props: { valor: Number },
  data: function data() {
    return {};
  },
  methods: {
    cambiar_giro: function cambiar_giro(data) {
      this.$store.dispatch('CAMBIAR_GIRO', data);
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  components: {},
  data: function data() {
    return {
      ip: '', mail: '', pass: '', errores: [], regnombre: '', regcelular: '', avisos: [], cargando: '', cargandologin: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    vervideo: function vervideo() {
      $('#exampleModal').modal();
    },
    masinfo: function masinfo() {
      this.$router.push('/informacion');
    },

    logindeplaka: function logindeplaka() {
      if (this.verificarform() === true) {
        this.enviarloginapi();
      }
    },
    iregrestro: function iregrestro() {
      this.$router.push('/registro');
    },

    verificarform: function verificarform(event) {
      this.errores = [];
      if (this.mail === '') {
        this.errores.push("Indique su Mail/Celular");
      }
      if (this.pass === '') {
        this.errores.push("Indique una contraseña");
      }
      if (!this.errores.length) {
        return true;
      } else {
        return false;
      }
    },
    enviarloginapi: function enviarloginapi() {
      var _this = this;

      var empresa = this.$store.getters.url_empresa;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/login/', {
        params: {
          "celular": this.mail, "pass": this.pass, "empresa": empresa
        }
      }).then(function (response) {
        return _this.pasologinapi(response);
      }, function (response) {
        return _this.errorloginapi(response);
      }).catch(function (response) {
        return _this.errorloginapi(response);
      });
    },

    pasologinapi: function pasologinapi(respuesta) {
      if (respuesta.data.credenciales) {
        this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales);
        this.$store.dispatch('SET_EMPRESAREFERIDA', respuesta.data.empresareferida);
        this.$router.push('/listador');
      } else {
        this.errorloginapi(respuesta);
      }
    },
    errorloginapi: function errorloginapi(respuesta) {
      if (respuesta.data.estado && respuesta.data.estado != 1) {
        this.errores = [];
        this.errores.push("Error en los datos enviados");
      }
    },
    registrodeplak: function registrodeplak(event) {
      if (this.verificarformreg() === true) {
        this.cargando = 'Cargando....';
        event.preventDefault();
        event.stopPropagation();
        this.enviarregistroapi();
      }
    },
    verificarformreg: function verificarformreg(event) {
      this.avisos = [];
      if (this.regnombre === '') {
        this.avisos.push("Indique su Nombre");
      }
      if (this.regcelular === '') {
        this.avisos.push("Indique su Celular");
      } else {
        if (this.verificarcelular(this.regcelular) === false) {
          this.avisos.push("Número de Celular no válido");
        }
      }

      if (!this.avisos.length) {
        return true;
      } else {
        return false;
      }
    },
    verificarcelular: function verificarcelular(actual) {
      var re = /(\d{3})(\d{3})(\d{3})/g;
      var nuevo = actual.replace(re, "$1$2$3");
      var codigo = actual.replace(re, "$1");

      if (codigo <= 99) {
        switch (codigo) {
          case '091':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '092':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '093':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '094':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '095':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '096':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '097':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '098':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '099':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    enviarregistroapi: function enviarregistroapi() {
      var _this2 = this;

      var carpintero = [];
      var empresa = this.$store.getters.url_empresa;
      carpintero.push({ 'nombre': this.regnombre, 'tel': this.regcelular });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/registro/', {
        "usuario": carpintero, 2006: 1, "empresa": empresa
      }).then(function (response) {
        return _this2.pasoregistroapi(response);
      }, function (response) {
        return _this2.errorregistroapi(response);
      }).catch(function (response) {
        return _this2.errorregistroapi(response);
      });
    },

    pasoregistroapi: function pasoregistroapi(respuesta) {
      if (respuesta.data.estado === 1 && respuesta.data.credenciales) {
        this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales);
        this.$store.dispatch('SET_EMPRESAREFERIDA', respuesta.data.empresareferida);
        this.$router.push('/listador/1');
      } else {
        this.errorregistroapi(respuesta);
      }
    },
    errorregistroapi: function errorregistroapi(respuesta) {
      if (respuesta.data.estado === 8) {
        this.avisos = [];
        this.avisos.push("Ya tienes cuenta, enviamos un SMS con un link para acceder!");
      } else if (respuesta.data.estado && respuesta.data.estado != 1) {
        this.avisos = [];
        this.avisos.push("Error en los datos enviados");
      }
      this.cargando = '';
    },
    recuperarclave: function recuperarclave() {
      if (this.mail === '') {
        this.errores = [];
        this.errores.push("Indique su Celular");
      } else {
        this.errores = [];
        this.cargandologin = "Enviando SMS...";
        this.precuperacionclave();
      }
    },
    precuperacionclave: function precuperacionclave() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/recuperarclave/', {
        params: {
          "celular": this.mail
        }
      }).then(function (response) {
        return _this3.pasoprecuperacionclave(response);
      }, function (response) {
        return _this3.errorprecuperacionclave(response);
      }).catch(function (response) {
        return _this3.errorprecuperacionclave(response);
      });
    },
    pasoprecuperacionclave: function pasoprecuperacionclave(response) {
      if (response.data.estado === 1) {
        Swal('SMS Enviado', 'Enviamos un SMS con un link para acceder!', 'success');
        this.cargandologin = '';
      } else {
        Swal('Error...', 'No pudimos enviar el SMS,verifica el telefono', 'error');
        this.cargandologin = '';
      }
    },
    errorprecuperacionclave: function errorprecuperacionclave(response) {}
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Actualizarregistro__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pedidos',
  components: { Actualizar: __WEBPACK_IMPORTED_MODULE_1__Actualizarregistro__["a" /* default */] },
  data: function data() {
    return {
      errores: []
    };
  },
  created: function created() {
    if (!this.$store.getters.islogin) {
      this.$router.push('/login');
    } else {
      this.consultarpedidosapi();
    }
  },

  methods: {
    consultarpedidosapi: function consultarpedidosapi() {
      var _this = this;

      if (this.$store.getters.islogin === true) {
        var empresa = this.$store.getters.url_empresa;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/pedidos/', {
          params: {
            'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual, "empresa": empresa
          }
        }).then(function (response) {
          return _this.procesarpedidos(response);
        }, function (response) {
          return _this.errorprocesarpedidos(response);
        }).catch(function (response) {
          return _this.errorprocesarpedidos(response);
        });
      } else {
        errorprocesarpedidos('notcred');
      }
    },
    procesarpedidos: function procesarpedidos(response) {
      if (response.data.estado === 1) {
        this.$store.dispatch('SET_PEDIDOS', response.data.pedidos);
      }
    },
    errorprocesarpedidos: function errorprocesarpedidos(response) {
      console.log(response);
    },
    verpedido: function verpedido(id) {
      this.$router.push('/pedido/' + id);
    },
    volveratras: function volveratras() {
      this.$router.push('/listador');
    },
    marcarpedido: function marcarpedido(pedido, key) {
      var _this2 = this;

      var empresa = this.$store.getters.url_empresa;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/marcarpedido', {
        'pedido': pedido, 'estado': 3, 'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual, "empresa": empresa
      }).then(function (response) {
        return _this2.pasomarcarpedidoapi(response, key);
      }, function (response) {
        return _this2.errormarcarpedidoapi(response);
      }).catch(function (response) {
        return _this2.errormarcarpedidoapi(response);
      });
    },
    pasomarcarpedidoapi: function pasomarcarpedidoapi(response, key) {
      if (response.data.estado === 1) {
        this.procesarpedidos(response);
      }
    },
    errormarcarpedidoapi: function errormarcarpedidoapi(response) {
      console.log('error');
    }
  },
  computed: {
    listapedidos: function listapedidos() {
      return _.orderBy(this.$store.getters.pedidos, ['id'], ['desc']);
    },
    pedidos: function pedidos() {
      return _.orderBy(this.$store.getters.pedidos, ['id'], ['desc']);
    }
  },
  watch: {}
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pedido',
  components: {},
  data: function data() {
    return {
      errores: [], pedido: '', lineas: '', estado: 2
    };
  },

  props: ['id'],
  mounted: function mounted() {
    this.consultarpedidoapi();
  },

  methods: {
    listapiezas: function listapiezas(lista) {
      return _.orderBy(lista, ['id'], ['desc']);
    },
    consultarpedidoapi: function consultarpedidoapi() {
      var _this = this;

      if (this.$store.getters.islogin === true) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.$apibase + 'gen/verpedido/', {
          params: {
            'id': this.id, 'cred': this.$store.getters.credactual, '4665': this.$store.getters.idactual
          }
        }).then(function (response) {
          return _this.procesarpedido(response);
        }, function (response) {
          return _this.errorprocesarpedido(response);
        }).catch(function (response) {
          return _this.errorprocesarpedido(response);
        });
      } else {
        errorprocesarpedido('notcred');
      }
    },
    procesarpedido: function procesarpedido(response) {
      if (response.data.estado === 1) {
        this.estado = 1;
        this.lineas = response.data.lineas;
        this.pedido = response.data.pedido;
      }
    },
    errorprocesarpedido: function errorprocesarpedido(response) {
      this.estado = 2;
      console.log(response);
    },
    volverpedidos: function volverpedidos() {
      if (this.pedido.estado !== 8) {
        this.$router.push('/pedidos');
      } else {
        this.$router.go(-1);
      }
    },
    descargararchivo: function descargararchivo() {
      window.open(this.pedido.urlarchivo, '_blank');
    },

    colorescanto1: function colorescanto1(canto) {
      if (canto === 1) {
        return 'canto1azul';
      } else if (canto === 2) {
        return 'canto1rojo';
      } else {
        return 'canto1gris';
      }
    },
    colorescanto2: function colorescanto2(canto) {
      canto = _.parseInt(canto);
      if (canto === 1) {
        return 'canto2azul';
      } else if (canto === 2) {
        return 'canto2rojo';
      } else {
        return 'canto2gris';
      }
    },
    colorescanto3: function colorescanto3(canto) {
      if (canto === 1) {
        return 'canto3azul';
      } else if (canto === 2) {
        return 'canto3rojo';
      } else {
        return 'canto3gris';
      }
    },
    colorescanto4: function colorescanto4(canto) {
      if (canto === 1) {
        return 'canto4azul';
      } else if (canto === 2) {
        return 'canto4rojo';
      } else {
        return 'canto4gris';
      }
    },
    enviarabiblioteca: function enviarabiblioteca() {
      var url = '/enviarabiblioteca/' + this.pedido.id;
      this.$router.push(url);
    },
    enviarapedido: function enviarapedido() {
      var actuales = 0;
      if (this.$store.getters.cantidadpiezas >= 1) {
        actuales = _.maxBy(this.$store.getters.piezas, function (o) {
          return o.id;
        });
        actuales = actuales['id'];
      }
      var store = this.$store;
      _.forEach(this.lineas, function (value, key) {
        actuales = ++actuales;
        var nuevapieza = { id: actuales, cantidad: value.cantidad, largo: value.largo, ancho: value.ancho, canto1: value.canto1, canto2: value.canto2, canto3: value.canto3, canto4: value.canto4, giro: value.giro, detalle: value.descripcion };
        store.commit('AGREGAR_PIEZA_DE_BIBLIOTECA_MUTATION', nuevapieza);
      });
      this.$router.push('/listador');
    }
  },
  computed: {
    totalmts2: function totalmts2() {
      var piezas = this.lineas;
      var total = this.$store.getters.cal_totalmt2(piezas);
      return total;
    },
    totalmtl045: function totalmtl045() {
      var piezas = this.lineas;
      var total = this.$store.getters.cal_totalmtl045(piezas);
      return total;
    },
    totalmtl2: function totalmtl2() {
      var piezas = this.lineas;
      var total = this.$store.getters.cal_totalmtl2(piezas);
      return total;
    },
    totalcorte: function totalcorte() {
      var piezas = this.lineas;
      var total = this.$store.getters.cal_totalmtcortes(piezas);
      return total;
    },
    lugarenvio: function lugarenvio() {
      if (this.estado === 1) {
        if (this.pedido.idcliente === this.pedido.idproveedor) {
          return 'mi mail el ' + this.pedido.fecha;
        } else if (this.pedido.idproveedor === 1) {
          return 'mi dispositivo el ' + this.pedido.fecha;
        } else {
          var pro = parseInt(this.pedido.idproveedor);
          var datos = this.$store.getters.datosproveedor(pro);
          if (datos) {
            return datos.nombre + ' el ' + this.pedido.fecha;
          } else {
            return this.pedido.fecha;
          }
        }
      }
      return false;
    },
    fecha_recibido: function fecha_recibido() {
      if (this.pedido.fecha_recibido) {
        return this.pedido.fecha_recibido;
      } else {
        return false;
      }
    },
    nombrematerial: function nombrematerial() {
      if (this.pedido.material == 2) {
        return 'Melamínico Otro MDF 18mm 2600x1830';
      } else if (this.pedido.material == 3) {
        return 'Melamínico Otro MDF 18mm 2750x1830';
      } else {
        return 'Melamínico Blanco MDF 18mm 2600x1830';
      }
    },
    colorplaca: function colorplaca() {
      if (this.pedido.material >= 2) {
        return 'Color: ' + this.pedido.colorplaca;
      }
    },
    colorcanto: function colorcanto() {
      return 'Color: ' + this.pedido.colorcanto;
    },
    cargacompleta: function cargacompleta() {
      if (this.estado == 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {}
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Registroproveedores_vue__ = __webpack_require__(145);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Registro',
  components: { proveedor: __WEBPACK_IMPORTED_MODULE_1__Registroproveedores_vue__["a" /* default */] },
  data: function data() {
    return {
      avisos: [], mail: '', celular: '', nombre: '', direccion: '', pass: '', proveedores: [], barracas: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    registrodeplak: function registrodeplak(event) {
      if (this.verificarform() === true) {
        event.preventDefault();
        event.stopPropagation();
        this.enviarregistroapi();
      }
    },
    atras: function atras() {
      this.$router.push('/listador');
    },
    iralogin: function iralogin() {
      this.$router.push('/login');
    },

    verificarform: function verificarform(event) {
      this.avisos = [];
      if (this.nombre === '') {
        this.avisos.push("Indique su Nombre");
      }
      if (this.celular === '') {
        this.avisos.push("Indique su Celular");
      } else {
        if (this.verificarcelular(this.celular) === false) {
          this.avisos.push("Número de Celular no válido");
        }
      }

      if (!this.avisos.length) {
        return true;
      } else {
        return false;
      }
    },
    verificarcelular: function verificarcelular(actual) {
      var re = /(\d{3})(\d{3})(\d{3})/g;
      var nuevo = actual.replace(re, "$1$2$3");
      var codigo = actual.replace(re, "$1");

      if (codigo <= 99) {
        switch (codigo) {
          case '091':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '092':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '093':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '094':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '095':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '096':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '097':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '098':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          case '099':
            if (nuevo.length == "9") {
              return nuevo;
            } else {
              return false;
            }
            break;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    enviarregistroapi: function enviarregistroapi() {
      var _this = this;

      var carpintero = [];
      carpintero.push({ 'nombre': this.nombre, 'tel': this.celular });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$apibase + 'gen/registro/', {
        "usuario": carpintero, 2006: 1
      }).then(function (response) {
        return _this.pasoregistroapi(response);
      }, function (response) {
        return _this.errorregistroapi(response);
      }).catch(function (response) {
        return _this.errorregistroapi(response);
      });
    },

    pasoregistroapi: function pasoregistroapi(respuesta) {
      if (respuesta.data.estado === 1 && respuesta.data.credenciales) {
        this.$store.dispatch('SET_CREDENCIALES', respuesta.data.credenciales);
        this.$router.push('/listador/1');
      } else {
        this.errorregistroapi(respuesta);
      }
    },
    errorregistroapi: function errorregistroapi(respuesta) {
      if (respuesta.data.estado === "-1") {
        this.avisos = [];
        this.avisos.push("El usuario ya existe, recupere su clave");
      } else if (respuesta.data.estado && respuesta.data.estado != 1) {
        this.avisos = [];
        this.avisos.push("Error en los datos enviados");
      }
    },
    cambiarproveedor: function cambiarproveedor(valor) {
      console.log(valor);
    }
  },
  computed: {},
  watch: {}
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'proveedor',
  components: {},
  data: function data() {
    return {};
  },

  props: ['name'],
  mounted: function mounted() {},

  methods: {},
  computed: {
    nombre: {
      get: function get() {
        return this.name;
      },
      set: function set(value) {
        this.$emit('proveedor:change', this.nombre);
      }
    }
  },
  watch: {}
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_simple_svg__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_simple_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_simple_svg__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_simple_svg___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$apibase = 'https://api.muebles.uy/';

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */],
  beforeCreate: function beforeCreate() {
    this.$store.commit('initialiseStore');
  },

  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c951cd9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(63);
function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c951cd9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"principal"}},[_c('header',[_c('nav',{staticClass:"navbar navbar-expand-lg azulnav"},[_c('a',{staticClass:"navbar-brand text-white",staticStyle:{"max-height":"80px"},attrs:{"href":"#"},on:{"click":function($event){_vm.inicio()}}},[_c('img',{staticClass:"d-inline-block align-top",attrs:{"src":"https://muebles.uy/muebles-cdn/logodeplaka.svg","height":"30","alt":"DEPLAKA Cortes a su Medida"}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbarTogglerDemo01"}},[(_vm.islogin === true)?_c('ul',{staticClass:"navbar-nav mr-auto mt-2 mt-lg-0"},[(this.$store.getters.accesodeplakcompleto === true)?_c('li',{staticClass:"nav-item",attrs:{"data-toggle":"collapse","data-target":"#navbarTogglerDemo01"}},[_c('a',{staticClass:"nav-link text-white",attrs:{"href":"#"},on:{"click":function($event){_vm.irabiblioteca()}}},[_vm._v(" Biblioteca")])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"data-toggle":"collapse","data-target":"#navbarTogglerDemo01"}},[_c('a',{staticClass:"nav-link text-white",attrs:{"href":"#"},on:{"click":function($event){_vm.irapedidos()}}},[_vm._v(" Pedidos")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"data-toggle":"collapse","data-target":"#navbarTogglerDemo01"}},[_c('a',{staticClass:"nav-link text-white"},[_vm._v(_vm._s(this.nombreusuario))])])]):_c('ul',{staticClass:"navbar-nav mr-auto mt-2 mt-lg-0"},[_c('li',{staticClass:"nav-item",attrs:{"data-toggle":"collapse","data-target":"#navbarTogglerDemo01"}},[_c('a',{staticClass:"nav-link text-white",on:{"click":function($event){_vm.iniciarsesion()}}},[_vm._v("Iniciar Sesion")])])])])])]),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navbarTogglerDemo01","aria-controls":"navbarTogglerDemo01","aria-expanded":"false","aria-label":"Toggle navigation"}},[_c('i',{staticClass:"fa fa-bars colorblanco",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Auth_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Enviarbiblioteca_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Biblioteca_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pedidocompleto_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Categoria_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Confirmacionpedido_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Enviarpedido_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Inicio_vue__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Informacion_vue__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Listador_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Login_vue__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Pedidos_vue__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Pedido_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Registro_vue__ = __webpack_require__(143);


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Inicio',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Inicio_vue__["a" /* default */]
  }, {
    path: '/informacion',
    name: 'Informacion',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Informacion_vue__["a" /* default */]
  }, {
    path: '/listador/:msg?',
    name: 'Listador',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Listador_vue__["a" /* default */],
    props: true
  }, {
    path: '/procesarpedido',
    name: 'Enviar',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Enviarpedido_vue__["a" /* default */]
  }, {
    path: '/pedidocompleto/:idnuevo/:guardar?',
    name: 'Completo',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Pedidocompleto_vue__["a" /* default */],
    props: true
  }, {
    path: '/pedidos',
    name: 'Pedidos',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Pedidos_vue__["a" /* default */]
  }, {
    path: '/pedido/:id',
    name: 'Pedido',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Pedido_vue__["a" /* default */],
    props: true
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Login_vue__["a" /* default */]
  }, {
    path: '/auth/:usr/cred/:auth',
    name: 'Auth',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Auth_vue__["a" /* default */],
    props: true
  }, {
    path: '/confirmacionpedido/:usr/cred/:auth/pedido/:pedido',
    name: 'Confirmacionpedido',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Confirmacionpedido_vue__["a" /* default */],
    props: true
  }, {
    path: '/enviarabiblioteca/:pedidolocal',
    name: 'Enviarbiblioteca',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Enviarbiblioteca_vue__["a" /* default */],
    props: true
  }, {
    path: '/biblioteca',
    name: 'Biblioteca',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Biblioteca_vue__["a" /* default */]
  }, {
    path: '/categoria/:slug/:msg?',
    name: 'Categoria',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Categoria_vue__["a" /* default */],
    props: true
  }, {
    path: '/registro',
    name: 'Registro',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Registro_vue__["a" /* default */]
  }]
}));

/***/ }),
/* 65 */,
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_auth_js__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a9fe35_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__ = __webpack_require__(86);
function injectStyle (ssrContext) {
  __webpack_require__(67)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_auth_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a9fe35_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Auth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(this.$store.getters.islogin === true)?_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Verificando credenciales de "+_vm._s(this.$store.getters.nombreusuario)+"....")])]):_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h3',[_vm._v("Cargando....")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_enviarbiblioteca_js__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c809296_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Enviarbiblioteca_vue__ = __webpack_require__(89);
function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_enviarbiblioteca_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c809296_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Enviarbiblioteca_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"enviarbiblioteca"}},[_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('div',{staticClass:"row"},[(this.pedido.id != '')?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\r\n\t\t    Pedido # "+_vm._s(this.pedido.id)+": "+_vm._s(this.pedido.descripcion)+"\r\n\t\t  ")]),_vm._v(" "),_c('div',{staticClass:"card-body text-justify"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.categorias),function(value,key){return (_vm.categorias !== '' && _vm.categorias !== null)?_c('div',{staticClass:"col-12 text-left"},[_c('div',{staticClass:"categoria_btn",on:{"click":function($event){_vm.enviarbiblioteca(value.id, _vm.pedido.id)}}},[_c('button',{staticClass:"btn btn-link btn-warning btn-lg",attrs:{"type":"button"}},[_c('img',{staticClass:"imgfolder",attrs:{"src":"https://muebles.uy/muebles-cdn/iconos/folder.svg"}}),_vm._v(" "),_c('p',{staticClass:"titulo_categoria"},[_vm._v(_vm._s(value.nombre))])])])]):_vm._e()}),_vm._v(" "),(_vm.categorias === '')?_c('div',[_c('p',{staticClass:"titulo_categoria"},[_vm._v("Cargando...")])]):_vm._e()],2)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row pt-3"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('h5',{staticClass:"card-title"},[_vm._v("Seleccione la carpeta dónde se guardará:")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_biblioteca_js__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4094586a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Biblioteca_vue__ = __webpack_require__(94);
function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_biblioteca_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4094586a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Biblioteca_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"biblioteca"}},[_c('Actualizar'),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('h3',[_vm._v("Biblioteca Personal")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{attrs:{"id":"piezacorte"},on:{"submit":function($event){$event.preventDefault();return _vm.crearcategoria($event)}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-8 text-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombrecategoria),expression:"nombrecategoria"}],staticClass:"form-control normal-input",attrs:{"type":"text","placeholder":"Nombre de Carpeta","name":"descripcion"},domProps:{"value":(_vm.nombrecategoria)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombrecategoria=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-2 text-left"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.crearcategoria()}}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v(" Crear")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.categorias),function(value,key){return (_vm.categorias !== '')?_c('div',{staticClass:"col-12 text-left"},[_c('div',{staticClass:"categoria_btn",on:{"click":function($event){_vm.ircategoria(value.slug)}}},[_c('button',{staticClass:"btn btn-link btn-warning btn-lg",attrs:{"type":"button"}},[_c('img',{staticClass:"imgfolder",attrs:{"src":"https://muebles.uy/muebles-cdn/iconos/folder.svg"}}),_vm._v(" "),_c('p',{staticClass:"titulo_categoria"},[_vm._v(_vm._s(value.nombre))])])])]):_vm._e()}),_vm._v(" "),(_vm.categorias === '')?_c('div',[_c('p',{staticClass:"titulo_categoria"},[_vm._v("Cargando...")])]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"row pt-3"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_pedidocompleto_js__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e1379ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pedidocompleto_vue__ = __webpack_require__(97);
function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_pedidocompleto_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e1379ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pedidocompleto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-12 col-xs-12 pl-5"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[(this.$store.getters.escarpintero === false)?_c('div',[_c('p',[_vm._v("Enviamos un SMS al móvil indicado, para confirmarlo por favor haga clic en el enlace.\n                ")])]):_vm._e()]),_vm._v(" "),(this.alertapedidoguardado === 1)?_c('div',[_vm._m(1)]):_vm._e(),_vm._v(" "),(this.$store.getters.accesodeplakcompleto === true)?_c('div',[(this.alertapedidoguardado === 0 && this.$store.getters.escarpintero === true)?_c('div',{staticClass:"row"},[_c('h4',{staticClass:"text-center"},[_vm._v("¿Quieres Guardarlo en tu Biblioteca?")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_vm._m(2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.biblioteca),expression:"biblioteca"}],staticClass:"custom-select",attrs:{"id":"biblioteca"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.biblioteca=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0","selected":""}},[_vm._v("Seleccione...")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Sí")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("No")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(this.biblioteca === '1')?_c('div',{staticClass:"input-group mb-3"},[_vm._m(3),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.carpeta),expression:"carpeta"}],staticClass:"custom-select col",attrs:{"id":"carpeta"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.carpeta=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.categoriasbiblioteca),function(value,key){return _c('option',{domProps:{"value":value.id}},[_vm._v(_vm._s(value.nombre))])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.errores.length)?_c('p',[_c('b',[_vm._v("Verifique lo(s) siguiente(s) errores:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errores),function(error){return _c('li',[_vm._v(_vm._s(error))])}))]):_vm._e()]),_vm._v(" "),(this.alertapedidoguardado === 0)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-12 pt-2"},[_c('div',{staticClass:"float-right pr-2"},[(_vm.verificarformb === true)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.guardarbiblioteca($event)}}},[_vm._v("Guardar")]):_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":""}},[_vm._v("Guardar")])])])]):_vm._e(),_vm._v(" "),(this.sologuardar === 1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-12 pt-2"},[_c('div',{staticClass:"float-left pr-2"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.iralarchivo(_vm.urldescarga)}}},[_vm._v("Descargar Archivo")])])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-12 pt-2"},[_c('div',{staticClass:"float-right pr-2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.volveratras()}}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Volver")]),_vm._v(" "),(this.$store.getters.escarpintero === false)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.loginmuebles()}}},[_vm._v("Ver Estado")]):_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.verpedido()}}},[_vm._v("Ver Pedidos")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('h2',{staticClass:"text-center"},[_vm._v("Pedido Enviado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning alert-dismissible fade show",attrs:{"role":"alert"}},[_c('strong',[_vm._v("Perfecto!")]),_vm._v(" Pedido guardado\n          "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text",attrs:{"for":"biblioteca"}},[_vm._v("¿Guardarlo?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text",attrs:{"for":"biblioteca"}},[_vm._v("Carpeta:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_categoria_js__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58dc318d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categoria_vue__ = __webpack_require__(100);
function injectStyle (ssrContext) {
  __webpack_require__(99)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_categoria_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58dc318d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categoria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"biblioteca"}},[_c('div',{staticClass:"col-md-12 col-xs-12"},[(_vm.categoria !== '')?_c('h3',[_vm._v("Proyectos en "+_vm._s(_vm.categoria.nombre))]):_vm._e(),_vm._v(" "),(_vm.alerta != 0)?_c('div',[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.pedidos !== '')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive my-3"},[_c('table',{staticClass:"table table-striped table-sm",attrs:{"id":"tabla_piezas"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.pedidos),function(value,key){return _c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(value.id)+" \r\n\t\t\t      \t\r\n\t\t\t      \t"),_c('button',{staticClass:"btn btn-outline-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.irpedido(value.id)}}},[_vm._v(" Ver ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.descripcion))]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(value.fecha))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.cantpiezas))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-outline-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.eliminarpedido(value.id)}}},[_c('i',{staticClass:"fa fa-window-close",attrs:{"aria-hidden":"true"}})])])])}))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn-sm btn-primary mr-2",attrs:{"type":"button"},on:{"click":function($event){_vm.volveratras()}}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Volver")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning alert-dismissible fade show",attrs:{"role":"alert"}},[_c('strong',[_vm._v("Perfecto!")]),_vm._v(" se copió tu lista\r\n\t\t  "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Descripcion")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Fecha")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Piezas")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Eliminar")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_confirmacionpedido_js__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_684ba4c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmacionpedido_vue__ = __webpack_require__(103);
function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_confirmacionpedido_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_684ba4c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmacionpedido_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(this.$store.getters.islogin === true && _vm.cargado === false)?_c('div',{staticClass:"col-12"},[_c('h3',[_vm._v("Verificando credenciales de "+_vm._s(this.$store.getters.nombreusuario)+"....")])]):_c('div',{staticClass:"col-md-12 col-sm-12"},[(_vm.cargado === false)?_c('h3',[_vm._v("Cargando....")]):_vm._e()]),_vm._v(" "),(_vm.cargado === true)?_c('div',{staticClass:"col-12"},[_c('h4',[_vm._v("Pedido Confirmado")]),_vm._v(" "),_c('h5',[_vm._v("¡Perfecto!")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.errores.length)?_c('p',[_c('b',[_vm._v("Verifique lo(s) siguiente(s) errores:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errores),function(error){return _c('li',[_vm._v(_vm._s(error))])}))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_enviarpedido_js__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528a7dfc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Enviarpedido_vue__ = __webpack_require__(106);
function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_enviarpedido_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528a7dfc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Enviarpedido_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-xs-12 pl-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{attrs:{"id":"corte"}},[(this.$store.getters.escarpintero === false)?_c('div',{attrs:{"id":"sinlogin"}},[(this.$store.getters.islogin !== true)?_c('div',{attrs:{"id":"islogin"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4 col-xs-4 text-left"},[_c('label',{attrs:{"for":"nombre"}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",class:_vm.clasenombre,attrs:{"type":"text","autocomplete":"off","name":"nombre","placeholder":"Nombre"},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4 col-xs-4 text-left"},[_c('label',{attrs:{"for":"telefono"}},[_vm._v("Teléfono:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telefono),expression:"telefono"}],staticClass:"form-control",class:_vm.clasetelefono,attrs:{"type":"text","autocomplete":"off","name":"telefono","placeholder":"09X-111222"},domProps:{"value":(_vm.telefono)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telefono=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8 col-xs-8 text-left"},[_c('label',{attrs:{"for":"mail"}},[_vm._v("Mail:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mail),expression:"mail"}],staticClass:"form-control",class:_vm.clasemail,attrs:{"type":"mail","autocomplete":"off","name":"mail","placeholder":"mail@gmail.com"},domProps:{"value":(_vm.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mail=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-8 col-xs-8 text-left"},[_c('label',{attrs:{"for":"direccion"}},[_vm._v("Dirección:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.direccion_barraca),expression:"direccion_barraca"}],staticClass:"form-control",class:_vm.clasedireccion,attrs:{"type":"text","autocomplete":"off","name":"direccion","placeholder":"Dirección"},domProps:{"value":(_vm.direccion_barraca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.direccion_barraca=$event.target.value}}})])])]):_c('div',[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.errores.length)?_c('p',[_c('b',[_vm._v("Verifique lo(s) siguiente(s) errores:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errores),function(error){return _c('li',[_vm._v(_vm._s(error))])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-12 pt-2"},[_c('div',{staticClass:"float-right pr-2"},[(_vm.verificarform === true)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.cargarpedido($event)}}},[_vm._v("Enviar")]):_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":""}},[_vm._v("Enviar")])]),_vm._v(" "),_c('div',{staticClass:"float-right pr-2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.volveratras()}}},[_vm._v("Volver")])])])])]):_c('div',{staticClass:"col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"input-group"},[_vm._m(2),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.lugar),expression:"lugar"}],staticClass:"custom-select",attrs:{"id":"lugar"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.lugar=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0","selected":""}},[_vm._v("Seleccione...")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("Guardar en este dispositivo")]),_vm._v(" "),_c('option',{domProps:{"value":this.$store.getters.idactual}},[_vm._v("A mi Mail")]),_vm._v(" "),_vm._l((_vm.proveedores),function(value,key){return _c('option',{domProps:{"value":value.id}},[_vm._v(_vm._s(value.nombre))])})],2)])]),_vm._v(" "),(_vm.verificarenviobarraca)?_c('div',{staticClass:"row",attrs:{"id":"info_barraca"}},[_c('h3',{staticClass:"text-center"},[_vm._v("Dónde quieres recibirlo:")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.direccion_barraca),expression:"direccion_barraca"}],staticClass:"form-control input_direccion",attrs:{"type":"text","maxlength":"100","autocomplete":"off","name":"direccion_barraca","placeholder":"Calle + Nro Puerta"},domProps:{"value":(_vm.direccion_barraca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.direccion_barraca=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.errores.length)?_c('p',[_c('b',[_vm._v("Verifique lo(s) siguiente(s) errores:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errores),function(error){return _c('li',[_vm._v(_vm._s(error))])}))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-12 pt-2"},[_c('div',{staticClass:"float-right pr-2"},[(_vm.verificarformlogin === true)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.cargarpedido($event)}}},[_vm._v("Enviar")]):_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":""}},[_vm._v("Enviar")])]),_vm._v(" "),_c('div',{staticClass:"float-right pr-2"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.volveratras()}}},[_vm._v("Volver")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center"},[_c('h2',{staticClass:"text-center"},[_vm._v("Elije dónde quieres enviar el Archivo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mb-5"},[_c('div',{staticClass:"col-xs-12 col-md-12 pt-2"},[_c('div',{staticClass:"alert alert-warning alert-dismissible fade show",attrs:{"role":"alert"}},[_vm._v("\n\t\t\t\t\t\t  Al pulsar enviar, te pediremos confirmes por SMS el pedido\n\t\t\t\t\t\t   "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text",attrs:{"for":"lugar"}},[_vm._v("Enviar Archivo:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text",attrs:{"for":"lugar"}},[_vm._v("Tu Calle:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_inicio_js__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0856adc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_inicio_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0856adc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col pb-2"},[_c('div',{staticClass:"card cardcarpintero"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title tituloscard1"},[_vm._v("Carpintero Mayorista")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-light",on:{"click":function($event){_vm.irregistro()}}},[_vm._v("Entrar")])])])]),_vm._v(" "),_c('div',{staticClass:"col "},[_c('div',{staticClass:"card cardcliente"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title tituloscard2"},[_vm._v("Cliente Final")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-light",on:{"click":function($event){_vm.irlistador()}}},[_vm._v("Entrar")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-1"},[_c('img',{attrs:{"alt":"Carpintero Mayorista","height":"150","src":"https://deplak.muebles.uy/images/iconcarpintero.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-1"},[_c('img',{attrs:{"alt":"Carpintero Mayorista","height":"150","src":"https://deplak.muebles.uy/images/iconfamilia.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_informacion_js__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70bcd930_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Informacion_vue__ = __webpack_require__(112);
function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_informacion_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70bcd930_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Informacion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 111 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"clas":"container"}},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-7 background-tranparent padding_fondo"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn bg-primary text-white ml-2",attrs:{"type":"button"},on:{"click":function($event){_vm.atras()}}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Volver")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-5 fondogris"},[_c('div',{staticClass:"row",attrs:{"id":"iniciarsesion"}},[_c('form',{staticClass:"form-signin"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-left"},[_c('label',{attrs:{"for":"inputnombre"}},[_vm._v("Nombre:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",attrs:{"id":"inputnombre","placeholder":"Nombre","required":"","autofocus":"","type":"text"},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"inputcelular"}},[_vm._v("Celular:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.celular),expression:"celular"}],staticClass:"form-control",attrs:{"id":"inputcelular","placeholder":"09X-111222","required":"","type":"text"},domProps:{"value":(_vm.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.celular=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"inputconsulta"}},[_vm._v("Consulta:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.consulta),expression:"consulta"}],staticClass:"form-control",attrs:{"rows":"3","cols":"50","id":"inputconsulta","placeholder":"Escriba su consulta"},domProps:{"value":(_vm.consulta)},on:{"input":function($event){if($event.target.composing){ return; }_vm.consulta=$event.target.value}}})]),_vm._v(" "),(_vm.avisos.length)?_c('div',[_c('b',[_vm._v("Verifique lo(s) siguiente(s) errores:")]),_vm._v(" "),_c('ul',_vm._l((_vm.avisos),function(error){return _c('li',[_vm._v(_vm._s(error))])}))]):_vm._e(),_vm._v(" "),(this.respuestaconsulta === '')?_c('div',[(this.cargandoconsulta === '')?_c('div',[_c('button',{staticClass:"btn btn-outline-primary btn-block mt-2",attrs:{"type":"submit"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.registrarconsulta($event)}}},[_vm._v("Consultar")])]):_c('div',[_vm._v("\n                  "+_vm._s(this.cargandoconsulta)+"\n                ")])]):_c('div',[_vm._m(2)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left p-2"},[_c('h4',{staticClass:"display-4"},[_vm._v("¿Sabés cómo funciona DEPLAK?")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("\n            Digitaliza tus listas usando simplemente tu celular\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("\n            Ve agregando pieza a pieza, con sus medidas; largo y ancho, selecciona si la pieza puede girar y los cantos que necesites.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Revisa en todo momento antes de enviar, puedes ir creando de a poco y enviar cuando quieras a la Barraca de siempre.\n          ")]),_vm._v(" "),_c('p',[_vm._v("\n            Queremos que puedas crear tus listas de forma cómoda y rápida en cualquier lugar que te encuentres, por eso creamos DEPLAK a tu servicio totalmente gratis.\n          ")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"h3 mb-1 font-weight-normal"},[_vm._v("¿Alguna Duda?"),_c('small',[_vm._v("Consúltanos acá")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning alert-dismissible fade show",attrs:{"role":"alert"}},[_c('strong',[_vm._v("¡Recibido!")]),_vm._v(" nos comunicaremos en breve.\n                  "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_listador_js__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f380352_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Listador_vue__ = __webpack_require__(133);
function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_listador_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f380352_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Listador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cantostodos_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68593a3f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cantostodos_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cantostodos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68593a3f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cantostodos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canto1_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223520e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canto1_vue__ = __webpack_require__(119);
function injectStyle (ssrContext) {
  __webpack_require__(118)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canto1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223520e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canto1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 0),expression:"valor === 0"}]},[_c('g',{attrs:{"id":"Largo1"}},[_c('path',{staticClass:"st8",attrs:{"d":"M650.2,122.5h7.4v51.1h24.5v6.2h-31.9V122.5z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M712.8,179.8l-0.6-5.2H712c-2.3,3.2-6.7,6.1-12.6,6.1c-8.3,0-12.6-5.9-12.6-11.8c0-9.9,8.8-15.4,24.7-15.3\r\n\t\tv-0.9c0-3.4-0.9-9.5-9.4-9.5c-3.8,0-7.8,1.2-10.7,3.1l-1.7-4.9c3.4-2.2,8.3-3.7,13.5-3.7c12.6,0,15.6,8.6,15.6,16.8v15.4\r\n\t\tc0,3.6,0.2,7.1,0.7,9.9H712.8z M711.7,158.8c-8.2-0.2-17.4,1.3-17.4,9.3c0,4.8,3.2,7.1,7.1,7.1c5.4,0,8.8-3.4,9.9-6.9\r\n\t\tc0.3-0.8,0.4-1.6,0.4-2.4V158.8z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M731,151.5c0-4.8-0.1-9-0.3-12.8h6.5l0.3,8.1h0.3c1.9-5.5,6.4-9,11.4-9c0.9,0,1.4,0.1,2.1,0.3v7.1\r\n\t\tc-0.8-0.2-1.5-0.3-2.6-0.3c-5.3,0-9,4-10,9.6c-0.2,1-0.3,2.2-0.3,3.5v21.9H731V151.5z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M793.6,138.7c-0.2,3-0.3,6.3-0.3,11.3v23.9c0,9.4-1.9,15.2-5.9,18.8c-4,3.7-9.8,4.9-15,4.9\r\n\t\tc-4.9,0-10.4-1.2-13.7-3.4l1.9-5.7c2.7,1.7,7,3.2,12.1,3.2c7.7,0,13.3-4,13.3-14.4v-4.6h-0.2c-2.3,3.8-6.7,6.9-13.1,6.9\r\n\t\tc-10.2,0-17.5-8.7-17.5-20.1c0-13.9,9.1-21.8,18.5-21.8c7.1,0,11.1,3.7,12.8,7.1h0.2l0.3-6.2H793.6z M785.8,154.9\r\n\t\tc0-1.3-0.1-2.4-0.4-3.4c-1.4-4.3-5-7.9-10.5-7.9c-7.1,0-12.2,6-12.2,15.6c0,8.1,4.1,14.8,12.2,14.8c4.6,0,8.8-2.9,10.4-7.7\r\n\t\tc0.4-1.3,0.6-2.7,0.6-4V154.9z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M842.9,158.9c0,15.2-10.5,21.8-20.5,21.8c-11.1,0-19.7-8.2-19.7-21.2c0-13.8,9-21.8,20.4-21.8\r\n\t\tC834.9,137.7,842.9,146.3,842.9,158.9z M810.2,159.3c0,9,5.2,15.8,12.5,15.8c7.1,0,12.5-6.7,12.5-16c0-7-3.5-15.8-12.3-15.8\r\n\t\tS810.2,151.5,810.2,159.3z"}})])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 1),expression:"valor === 1"}]},[_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"st5",attrs:{"d":"M689.9,117.5c6.9,0,12.1,2.8,15.8,8.3c3.6,5.5,5.4,13.6,5.4,24.1c0,10.5-1.8,18.6-5.4,24.1   c-3.6,5.6-8.9,8.3-15.8,8.3c-6.9,0-12.2-2.8-15.8-8.3c-3.6-5.5-5.4-13.6-5.4-24.1c0-10.5,1.8-18.5,5.4-24.1   C677.7,120.2,682.9,117.5,689.9,117.5z M689.9,124.1c-4.1,0-7.2,2.2-9.3,6.5c-2.1,4.4-3.2,10.8-3.2,19.2c0,8.3,1.1,14.7,3.2,19.1   c2.1,4.4,5.2,6.6,9.3,6.6c4,0,7-2.2,9.1-6.5c2.1-4.4,3.2-10.7,3.2-18.9c0-8.5-1-14.9-3.1-19.3C697,126.3,693.9,124.1,689.9,124.1z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M725.6,171.6h9.1l-7.4,20.7H720L725.6,171.6z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M771.2,118.6h10.5v41.6h9.1v6.9h-9.1v14h-8.2v-14H744v-8L771.2,118.6z M773.7,126.3l-22.6,33.9h22.4   L773.7,126.3z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M802.1,118.6h34.4v6.6h-26.3l-0.4,17.3c1.5-0.3,3-0.5,4.4-0.7c1.4-0.1,2.7-0.2,4.1-0.2   c6.4,0,11.5,1.7,15.2,5.1s5.6,8.1,5.6,13.9c0,6.5-2.2,11.6-6.7,15.4s-10.5,5.7-18.1,5.7c-2.2,0-4.4-0.2-6.6-0.6s-4.5-1-6.7-1.8   l-0.1-8.1c1.9,1.1,4,1.9,6.2,2.5s4.7,0.9,7.3,0.9c4.8,0,8.7-1.3,11.6-3.8s4.3-5.8,4.3-10c0-3.8-1.4-6.9-4.1-9.1s-6.4-3.4-11-3.4   c-1.8,0-3.8,0.2-6.1,0.5c-2.3,0.3-4.8,0.8-7.4,1.5L802.1,118.6z"}})])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 2),expression:"valor === 2"}]},[_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"_x32_nn"}},[_c('path',{staticClass:"st7",attrs:{"d":"M658.6,172.4h28.6v7.1h-39v-7.3c11.3-11.2,18.8-19.5,22.7-24.9c3.9-5.4,5.8-10.1,5.8-13.9   c0-2.9-1.1-5.3-3.2-7.1s-4.9-2.8-8.4-2.8c-2.3,0-4.7,0.4-7.1,1.1c-2.4,0.8-4.7,1.9-6.9,3.4l-1-8c2.9-1.3,5.8-2.3,8.7-3   c2.9-0.7,5.8-1,8.7-1c5.2,0,9.5,1.6,12.8,4.7c3.3,3.1,4.9,7.2,4.9,12.2c0,4.8-1.9,10.1-5.8,15.9   C675.6,154.8,668.6,162.6,658.6,172.4z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M737.9,143.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2c-1.4-2.1-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23H702v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C735,137.5,736.7,140,737.9,143.2z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M817.5,143.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2s-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23h-8.3v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C814.6,137.5,816.3,140,817.5,143.2z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canto2_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f2fcbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canto2_vue__ = __webpack_require__(122);
function injectStyle (ssrContext) {
  __webpack_require__(121)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canto2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f2fcbc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canto2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 0),expression:"valor === 0"}]},[_c('g',{attrs:{"id":"Largo2"}},[_c('path',{staticClass:"st8",attrs:{"d":"M650.7,748.2h7.4v51.1h24.5v6.2h-31.9V748.2z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M713.3,805.5l-0.6-5.2h-0.3c-2.3,3.2-6.7,6.1-12.6,6.1c-8.3,0-12.6-5.9-12.6-11.8c0-9.9,8.8-15.4,24.7-15.3\r\n\t\tv-0.9c0-3.4-0.9-9.5-9.4-9.5c-3.8,0-7.8,1.2-10.7,3.1l-1.7-4.9c3.4-2.2,8.3-3.7,13.5-3.7c12.6,0,15.6,8.6,15.6,16.8v15.4\r\n\t\tc0,3.6,0.2,7.1,0.7,9.9H713.3z M712.2,784.5c-8.2-0.2-17.4,1.3-17.4,9.3c0,4.8,3.2,7.1,7.1,7.1c5.4,0,8.8-3.4,9.9-6.9\r\n\t\tc0.3-0.8,0.4-1.6,0.4-2.4V784.5z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M731.5,777.2c0-4.8-0.1-9-0.3-12.8h6.5l0.3,8.1h0.3c1.9-5.5,6.4-9,11.4-9c0.9,0,1.4,0.1,2.1,0.3v7.1\r\n\t\tc-0.8-0.2-1.5-0.3-2.6-0.3c-5.3,0-9,4-10,9.6c-0.2,1-0.3,2.2-0.3,3.5v21.9h-7.4V777.2z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M794,764.4c-0.2,3-0.3,6.3-0.3,11.3v23.9c0,9.4-1.9,15.2-5.9,18.8c-4,3.7-9.8,4.9-15,4.9\r\n\t\tc-4.9,0-10.4-1.2-13.7-3.4l1.9-5.7c2.7,1.7,7,3.2,12.1,3.2c7.7,0,13.3-4,13.3-14.4v-4.6h-0.2c-2.3,3.8-6.7,6.9-13.1,6.9\r\n\t\tc-10.2,0-17.5-8.7-17.5-20.1c0-13.9,9.1-21.8,18.5-21.8c7.1,0,11.1,3.7,12.8,7.1h0.2l0.3-6.2H794z M786.3,780.6\r\n\t\tc0-1.3-0.1-2.4-0.4-3.4c-1.4-4.3-5-7.9-10.5-7.9c-7.1,0-12.2,6-12.2,15.6c0,8.1,4.1,14.8,12.2,14.8c4.6,0,8.8-2.9,10.4-7.7\r\n\t\tc0.4-1.3,0.6-2.7,0.6-4V780.6z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M843.3,784.6c0,15.2-10.5,21.8-20.5,21.8c-11.1,0-19.7-8.2-19.7-21.2c0-13.8,9-21.8,20.4-21.8\r\n\t\tC835.4,763.4,843.3,772,843.3,784.6z M810.7,785c0,9,5.2,15.8,12.5,15.8c7.1,0,12.5-6.7,12.5-16c0-7-3.5-15.8-12.3-15.8\r\n\t\tS810.7,777.2,810.7,785z"}})])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 1),expression:"valor === 1"}]},[_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"st5",attrs:{"d":"M685.9,744.5c6.9,0,12.1,2.8,15.8,8.3c3.6,5.5,5.4,13.6,5.4,24.1c0,10.5-1.8,18.6-5.4,24.1   c-3.6,5.6-8.9,8.3-15.8,8.3c-6.9,0-12.2-2.8-15.8-8.3c-3.6-5.5-5.4-13.6-5.4-24.1c0-10.5,1.8-18.5,5.4-24.1   C673.7,747.2,678.9,744.5,685.9,744.5z M685.9,751.1c-4.1,0-7.2,2.2-9.3,6.5c-2.1,4.4-3.2,10.8-3.2,19.2c0,8.3,1.1,14.7,3.2,19.1   c2.1,4.4,5.2,6.6,9.3,6.6c4,0,7-2.2,9.1-6.5c2.1-4.4,3.2-10.7,3.2-18.9c0-8.5-1-14.9-3.1-19.3C693,753.3,689.9,751.1,685.9,751.1z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M721.6,798.6h9.1l-7.4,20.7H716L721.6,798.6z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M767.2,745.6h10.5v41.6h9.1v6.9h-9.1v14h-8.2v-14H740v-8L767.2,745.6z M769.7,753.3l-22.6,33.9h22.4   L769.7,753.3z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M798.1,745.6h34.4v6.6h-26.3l-0.4,17.3c1.5-0.3,3-0.5,4.4-0.7c1.4-0.1,2.7-0.2,4.1-0.2   c6.4,0,11.5,1.7,15.2,5.1s5.6,8.1,5.6,13.9c0,6.5-2.2,11.6-6.7,15.4s-10.5,5.7-18.1,5.7c-2.2,0-4.4-0.2-6.6-0.6s-4.5-1-6.7-1.8   l-0.1-8.1c1.9,1.1,4,1.9,6.2,2.5s4.7,0.9,7.3,0.9c4.8,0,8.7-1.3,11.6-3.8s4.3-5.8,4.3-10c0-3.8-1.4-6.9-4.1-9.1s-6.4-3.4-11-3.4   c-1.8,0-3.8,0.2-6.1,0.5c-2.3,0.3-4.8,0.8-7.4,1.5L798.1,745.6z"}})])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 2),expression:"valor === 2"}]},[_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"_x32_nn_2_"}},[_c('path',{staticClass:"st7",attrs:{"d":"M657.6,800.4h28.6v7.1h-39v-7.3c11.3-11.2,18.8-19.5,22.7-24.9c3.9-5.4,5.8-10.1,5.8-13.9   c0-2.9-1.1-5.3-3.2-7.1s-4.9-2.8-8.4-2.8c-2.3,0-4.7,0.4-7.1,1.1c-2.4,0.8-4.7,1.9-6.9,3.4l-1-8c2.9-1.3,5.8-2.3,8.7-3   c2.9-0.7,5.8-1,8.7-1c5.2,0,9.5,1.6,12.8,4.7c3.3,3.1,4.9,7.2,4.9,12.2c0,4.8-1.9,10.1-5.8,15.9   C674.6,782.8,667.6,790.6,657.6,800.4z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M736.9,771.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2c-1.4-2.1-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23H701v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C734,765.5,735.7,768,736.9,771.2z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M816.5,771.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2s-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23h-8.3v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C813.6,765.5,815.3,768,816.5,771.2z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canto3_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0504c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canto3_vue__ = __webpack_require__(125);
function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canto3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0504c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canto3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 0),expression:"valor === 0"}]},[_c('g',{attrs:{"id":"ancho3"}},[_c('path',{staticClass:"st8",attrs:{"d":"M104.2,451.9l-6,18h-7.7l19.5-57.3h8.9l19.6,57.3h-7.9l-6.1-18H104.2z M123,446.2l-5.6-16.5\r\n\t\tc-1.3-3.7-2.1-7.1-3-10.5h-0.2c-0.9,3.4-1.8,6.9-2.9,10.4l-5.6,16.6H123z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M146.5,440c0-4.3-0.1-7.7-0.3-11.1h6.6l0.4,6.8h0.2c2-3.9,6.8-7.7,13.6-7.7c5.7,0,14.5,3.4,14.5,17.5V470H174\r\n\t\tv-23.7c0-6.6-2.5-12.2-9.5-12.2c-4.9,0-8.8,3.5-10,7.7c-0.3,0.9-0.5,2.2-0.5,3.5V470h-7.5V440z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M223,468.4c-2,1-6.3,2.4-11.8,2.4c-12.4,0-20.5-8.4-20.5-21c0-12.7,8.7-21.8,22.1-21.8c4.4,0,8.3,1.1,10.4,2.1\r\n\t\tl-1.7,5.8c-1.8-1-4.6-2-8.7-2c-9.4,0-14.5,7-14.5,15.6c0,9.5,6.1,15.4,14.3,15.4c4.3,0,7.1-1.1,9.2-2L223,468.4z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M231.7,409.6h7.5v25.7h0.2c1.2-2.1,3.1-4,5.4-5.3c2.2-1.3,4.8-2.1,7.7-2.1c5.5,0,14.4,3.4,14.4,17.6V470h-7.5\r\n\t\tv-23.6c0-6.6-2.5-12.2-9.5-12.2c-4.8,0-8.7,3.4-10,7.5c-0.4,1-0.5,2.1-0.5,3.6V470h-7.5V409.6z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M316.1,449c0,15.2-10.5,21.8-20.5,21.8c-11.1,0-19.7-8.2-19.7-21.2c0-13.8,9-21.8,20.4-21.8\r\n\t\tC308.1,427.9,316.1,436.5,316.1,449z M283.5,449.5c0,9,5.2,15.8,12.5,15.8c7.1,0,12.5-6.7,12.5-16c0-7-3.5-15.8-12.3-15.8\r\n\t\tS283.5,441.7,283.5,449.5z"}})])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 1),expression:"valor === 1"}]},[_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"st5",attrs:{"d":"M142.1,407.5c6.9,0,12.1,2.8,15.8,8.3c3.6,5.5,5.4,13.6,5.4,24.1c0,10.5-1.8,18.6-5.4,24.1   c-3.6,5.6-8.9,8.3-15.8,8.3c-6.9,0-12.2-2.8-15.8-8.3c-3.6-5.5-5.4-13.6-5.4-24.1c0-10.5,1.8-18.5,5.4-24.1   C130,410.2,135.2,407.5,142.1,407.5z M142.1,414.1c-4.1,0-7.2,2.2-9.3,6.5c-2.1,4.4-3.2,10.8-3.2,19.2c0,8.3,1.1,14.7,3.2,19.1   c2.1,4.4,5.2,6.6,9.3,6.6c4,0,7-2.2,9.1-6.5s3.2-10.7,3.2-18.9c0-8.5-1-14.9-3.1-19.3C149.3,416.3,146.2,414.1,142.1,414.1z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M177.9,461.6h9.1l-7.4,20.7h-7.3L177.9,461.6z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M223.5,408.6H234v41.6h9.1v6.9H234v14h-8.2v-14h-29.6v-8L223.5,408.6z M226,416.3l-22.6,33.9h22.4L226,416.3z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M254.4,408.6h34.4v6.6h-26.3l-0.4,17.3c1.5-0.3,3-0.5,4.4-0.7c1.4-0.1,2.7-0.2,4.1-0.2   c6.4,0,11.5,1.7,15.2,5.1s5.6,8.1,5.6,13.9c0,6.5-2.2,11.6-6.7,15.4s-10.5,5.7-18.1,5.7c-2.2,0-4.4-0.2-6.6-0.6s-4.5-1-6.7-1.8   l-0.1-8.1c1.9,1.1,4,1.9,6.2,2.5s4.7,0.9,7.3,0.9c4.8,0,8.7-1.3,11.6-3.8s4.3-5.8,4.3-10c0-3.8-1.4-6.9-4.1-9.1s-6.4-3.4-11-3.4   c-1.8,0-3.8,0.2-6.1,0.5c-2.3,0.3-4.8,0.8-7.4,1.5L254.4,408.6z"}})])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 2),expression:"valor === 2"}]},[_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"_x32_nn_3_"}},[_c('path',{staticClass:"st7",attrs:{"d":"M112.6,462.4h28.6v7.1h-39v-7.3c11.3-11.2,18.8-19.5,22.7-24.9c3.9-5.4,5.8-10.1,5.8-13.9   c0-2.9-1.1-5.3-3.2-7.1s-4.9-2.8-8.4-2.8c-2.3,0-4.7,0.4-7.1,1.1c-2.4,0.8-4.7,1.9-6.9,3.4l-1-8c2.9-1.3,5.8-2.3,8.7-3   c2.9-0.7,5.8-1,8.7-1c5.2,0,9.5,1.6,12.8,4.7c3.3,3.1,4.9,7.2,4.9,12.2c0,4.8-1.9,10.1-5.8,15.9   C129.6,444.8,122.6,452.6,112.6,462.4z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M191.9,433.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2c-1.4-2.1-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23H156v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C189,427.5,190.7,430,191.9,433.2z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M271.5,433.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2s-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23h-8.3v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C268.6,427.5,270.3,430,271.5,433.2z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canto4_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2db7b2dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canto4_vue__ = __webpack_require__(128);
function injectStyle (ssrContext) {
  __webpack_require__(127)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canto4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2db7b2dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canto4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 0),expression:"valor === 0"}]},[_c('g',{attrs:{"id":"ancho4"}},[_c('path',{staticClass:"st8",attrs:{"d":"M1234.3,453.6l-6,18h-7.7l19.5-57.3h8.9l19.6,57.3h-7.9l-6.1-18H1234.3z M1253.1,447.8l-5.6-16.5\r\n\t\tc-1.3-3.7-2.1-7.1-3-10.5h-0.2c-0.9,3.4-1.8,6.9-2.9,10.4l-5.6,16.6H1253.1z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M1276.6,441.6c0-4.3-0.1-7.7-0.3-11.1h6.6l0.4,6.8h0.2c2-3.9,6.8-7.7,13.6-7.7c5.7,0,14.5,3.4,14.5,17.5v24.6\r\n\t\th-7.5v-23.7c0-6.6-2.5-12.2-9.5-12.2c-4.9,0-8.8,3.5-10,7.7c-0.3,0.9-0.5,2.2-0.5,3.5v24.7h-7.5V441.6z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M1353.1,470.1c-2,1-6.3,2.4-11.8,2.4c-12.4,0-20.5-8.4-20.5-21c0-12.7,8.7-21.8,22.1-21.8\r\n\t\tc4.4,0,8.3,1.1,10.4,2.1l-1.7,5.8c-1.8-1-4.6-2-8.7-2c-9.4,0-14.5,7-14.5,15.6c0,9.5,6.1,15.4,14.3,15.4c4.3,0,7.1-1.1,9.2-2\r\n\t\tL1353.1,470.1z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M1361.8,411.3h7.5v25.7h0.2c1.2-2.1,3.1-4,5.4-5.3c2.2-1.3,4.8-2.1,7.7-2.1c5.5,0,14.4,3.4,14.4,17.6v24.5\r\n\t\th-7.5V448c0-6.6-2.5-12.2-9.5-12.2c-4.8,0-8.7,3.4-10,7.5c-0.4,1-0.5,2.1-0.5,3.6v24.8h-7.5V411.3z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M1446.3,450.7c0,15.2-10.5,21.8-20.5,21.8c-11.1,0-19.7-8.2-19.7-21.2c0-13.8,9-21.8,20.4-21.8\r\n\t\tC1438.3,429.6,1446.3,438.1,1446.3,450.7z M1413.6,451.1c0,9,5.2,15.8,12.5,15.8c7.1,0,12.5-6.7,12.5-16c0-7-3.5-15.8-12.3-15.8\r\n\t\tS1413.6,443.3,1413.6,451.1z"}})])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 1),expression:"valor === 1"}]},[_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{staticClass:"st5",attrs:{"d":"M1285.9,410.5c6.9,0,12.1,2.8,15.8,8.3c3.6,5.5,5.4,13.6,5.4,24.1c0,10.5-1.8,18.6-5.4,24.1   c-3.6,5.6-8.9,8.3-15.8,8.3c-6.9,0-12.2-2.8-15.8-8.3c-3.6-5.5-5.4-13.6-5.4-24.1c0-10.5,1.8-18.5,5.4-24.1   C1273.7,413.2,1278.9,410.5,1285.9,410.5z M1285.9,417.1c-4.1,0-7.2,2.2-9.3,6.5c-2.1,4.4-3.2,10.8-3.2,19.2   c0,8.3,1.1,14.7,3.2,19.1c2.1,4.4,5.2,6.6,9.3,6.6c4,0,7-2.2,9.1-6.5c2.1-4.4,3.2-10.7,3.2-18.9c0-8.5-1-14.9-3.1-19.3   C1293,419.3,1289.9,417.1,1285.9,417.1z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M1321.6,464.6h9.1l-7.4,20.7h-7.3L1321.6,464.6z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M1367.2,411.6h10.5v41.6h9.1v6.9h-9.1v14h-8.2v-14H1340v-8L1367.2,411.6z M1369.7,419.3l-22.6,33.9h22.4   L1369.7,419.3z"}}),_vm._v(" "),_c('path',{staticClass:"st5",attrs:{"d":"M1398.1,411.6h34.4v6.6h-26.3l-0.4,17.3c1.5-0.3,3-0.5,4.4-0.7c1.4-0.1,2.7-0.2,4.1-0.2   c6.4,0,11.5,1.7,15.2,5.1s5.6,8.1,5.6,13.9c0,6.5-2.2,11.6-6.7,15.4s-10.5,5.7-18.1,5.7c-2.2,0-4.4-0.2-6.6-0.6s-4.5-1-6.7-1.8   l-0.1-8.1c1.9,1.1,4,1.9,6.2,2.5s4.7,0.9,7.3,0.9c4.8,0,8.7-1.3,11.6-3.8s4.3-5.8,4.3-10c0-3.8-1.4-6.9-4.1-9.1s-6.4-3.4-11-3.4   c-1.8,0-3.8,0.2-6.1,0.5c-2.3,0.3-4.8,0.8-7.4,1.5L1398.1,411.6z"}})])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 2),expression:"valor === 2"}]},[_c('g',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"_x32_nn_1_"}},[_c('path',{staticClass:"st7",attrs:{"d":"M1255.6,464.4h28.6v7.1h-39v-7.3c11.3-11.2,18.8-19.5,22.7-24.9c3.9-5.4,5.8-10.1,5.8-13.9   c0-2.9-1.1-5.3-3.2-7.1s-4.9-2.8-8.4-2.8c-2.3,0-4.7,0.4-7.1,1.1c-2.4,0.8-4.7,1.9-6.9,3.4l-1-8c2.9-1.3,5.8-2.3,8.7-3   c2.9-0.7,5.8-1,8.7-1c5.2,0,9.5,1.6,12.8,4.7c3.3,3.1,4.9,7.2,4.9,12.2c0,4.8-1.9,10.1-5.8,15.9   C1272.6,446.8,1265.6,454.6,1255.6,464.4z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M1334.9,435.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2c-1.4-2.1-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23h-8.3v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C1332,429.5,1333.7,432,1334.9,435.2z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M1414.5,435.2c1.7-3.2,3.8-5.7,6.4-7.3c2.6-1.7,5.6-2.5,8.9-2.5c4.7,0,8.3,1.6,10.8,4.8   c2.5,3.2,3.7,7.9,3.7,14.1v27.3h-8.3v-25.4c0-4.5-0.7-7.9-2.2-10.1c-1.4-2.2-3.6-3.3-6.6-3.3c-3.6,0-6.5,1.4-8.5,4.2   c-2.1,2.8-3.1,6.7-3.1,11.6v23h-8.3v-25.4c0-4.7-0.7-8.1-2.1-10.2s-3.7-3.2-6.9-3.2c-3.4,0-6.1,1.4-8.1,4.3   c-2.1,2.8-3.1,6.7-3.1,11.5v23h-8.3v-45.2h7.7v8.3c1.6-3,3.7-5.4,6.2-7c2.5-1.6,5.4-2.4,8.7-2.4c3.2,0,5.9,0.8,8.1,2.5   C1411.6,429.5,1413.3,432,1414.5,435.2z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Giro_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9014f554_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Giro_vue__ = __webpack_require__(131);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Giro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9014f554_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Giro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 0),expression:"valor === 0"}],on:{"click":function($event){_vm.cambiar_giro(1)}}},[_c('g',{staticClass:"st5"},[_c('polygon',{staticClass:"st8",attrs:{"points":"767.8,378.7 747.1,363.2 767.8,347.8 759.3,336.5 723.7,363.2 759.3,390  "}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M799.8,542.5l4.1,13.5c4.8-1.5,9.5-3.3,14.1-5.5l-6.1-12.7C808,539.7,804,541.3,799.8,542.5z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M774.1,546.3v14.1c5,0,10.1-0.4,15.1-1.1l-2-13.9C782.8,546,778.5,546.3,774.1,546.3z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M858.8,401.3c-19-28.2-50.7-45.1-84.7-45.1v14.1c48.6,0,88,39.4,88,88c0,29.3-14.6,56.7-38.9,73l7.9,11.7\r\n    C877.9,511.5,890.3,448.1,858.8,401.3z"}}),_vm._v(" "),_c('path',{staticClass:"st8",attrs:{"d":"M709.9,386.7L657.1,511l92.5,39.3L802.4,426L709.9,386.7z M742.1,531.8l-66.5-28.2l41.7-98.3l66.5,28.2\r\n    L742.1,531.8z"}})]),_vm._v(" "),_c('g',[_c('g',[_c('g',[_c('polygon',{staticClass:"st9",attrs:{"points":"766.7,375.3 745.3,359.3 766.7,343.2 758,331.6 721,359.3 758,387      "}}),_vm._v(" "),_c('path',{staticClass:"st9",attrs:{"d":"M799.9,545l4.3,13.9c5-1.5,9.9-3.4,14.6-5.7l-6.3-13.1C808.4,542.1,804.2,543.7,799.9,545z"}}),_vm._v(" "),_c('path',{staticClass:"st9",attrs:{"d":"M773.3,549v14.6c5.2,0,10.4-0.4,15.6-1.1l-2.1-14.4C782.3,548.6,777.8,549,773.3,549z"}}),_vm._v(" "),_c('path',{staticClass:"st9",attrs:{"d":"M861.1,398.7c-19.7-29.2-52.6-46.7-87.8-46.7v14.6c50.4,0,91.2,40.8,91.2,91.2c0,30.4-15.1,58.7-40.3,75.7\r\n        l8.2,12.1C880.9,512.9,893.7,447.2,861.1,398.7z"}}),_vm._v(" "),_c('path',{staticClass:"st9",attrs:{"d":"M688.7,533.9H766c9.3,0,15.5-6.2,15.5-15.5v-61.9c0-9.3-6.2-15.5-15.5-15.5v-7.7c0-21.7-17-38.7-38.7-38.7\r\n        c-21.7,0-38.7,17-38.7,38.7v7.7c-9.3,0-15.5,6.2-15.5,15.5v61.9C673.2,527.7,679.4,533.9,688.7,533.9z"}}),_vm._v(" "),_c('path',{staticClass:"st7",attrs:{"d":"M701,433.4c0-13.9,12.4-26.3,26.3-26.3s26.3,12.4,26.3,26.3v7.7H701L701,433.4L701,433.4z"}})])])])]),_vm._v(" "),_c('g',{directives:[{name:"show",rawName:"v-show",value:(_vm.valor === 1),expression:"valor === 1"}],on:{"click":function($event){_vm.cambiar_giro(0)}}},[_c('g',[_c('polygon',{staticClass:"fillverde",attrs:{"points":"767.8,378.7 747.1,363.2 767.8,347.8 759.3,336.5 723.7,363.2 759.3,390 \t"}}),_vm._v(" "),_c('path',{staticClass:"fillverde",attrs:{"d":"M799.8,542.5l4.1,13.5c4.8-1.5,9.5-3.3,14.1-5.5l-6.1-12.7C808,539.7,804,541.3,799.8,542.5z"}}),_vm._v(" "),_c('path',{staticClass:"fillverde",attrs:{"d":"M774.1,546.3v14.1c5,0,10.1-0.4,15.1-1.1l-2-13.9C782.8,546,778.5,546.3,774.1,546.3z"}}),_vm._v(" "),_c('path',{staticClass:"fillverde",attrs:{"d":"M858.8,401.3c-19-28.2-50.7-45.1-84.7-45.1v14.1c48.6,0,88,39.4,88,88c0,29.3-14.6,56.7-38.9,73l7.9,11.7\r\n\t\tC877.9,511.5,890.3,448.1,858.8,401.3z"}}),_vm._v(" "),_c('path',{staticClass:"fillverde",attrs:{"d":"M709.9,386.7L657.1,511l92.5,39.3L802.4,426L709.9,386.7z M742.1,531.8l-66.5-28.2l41.7-98.3l66.5,28.2\r\n\t\tL742.1,531.8z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg-button"},[_c('svg',{staticStyle:{"enable-background":"new 0 0 1500 900"},attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 1500 900","xml:space":"preserve"}},[_c('svg',[_c('g',{attrs:{"id":"btn_canto1"},on:{"click":function($event){_vm.cambiar_canto(1)}}},[_c('path',{staticClass:"st0",attrs:{"d":"M613,244.5c-6.3,0-11.5-5.2-11.5-11.5V89c0-6.3,5.2-11.5,11.5-11.5h273c6.3,0,11.5,5.2,11.5,11.5v144\n    c0,6.3-5.2,11.5-11.5,11.5H613z"}}),_vm._v(" "),_c('path',{staticClass:"st0",attrs:{"d":"M886,78c6.1,0,11,4.9,11,11v144c0,6.1-4.9,11-11,11H613c-6.1,0-11-4.9-11-11V89c0-6.1,4.9-11,11-11H886\n     M886,77H613c-6.6,0-12,5.4-12,12v144c0,6.6,5.4,12,12,12h273c6.6,0,12-5.4,12-12V89C898,82.4,892.6,77,886,77L886,77z"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"btn_canto2"},on:{"click":function($event){_vm.cambiar_canto(2)}}},[_c('path',{staticClass:"st0",attrs:{"d":"M613,867.5c-6.3,0-11.5-5.2-11.5-11.5V712c0-6.3,5.2-11.5,11.5-11.5h273c6.3,0,11.5,5.2,11.5,11.5v144\n    c0,6.3-5.2,11.5-11.5,11.5H613z"}}),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M886,701c6.1,0,11,4.9,11,11v144c0,6.1-4.9,11-11,11H613c-6.1,0-11-4.9-11-11V712c0-6.1,4.9-11,11-11H886\n     M886,700H613c-6.6,0-12,5.4-12,12v144c0,6.6,5.4,12,12,12h273c6.6,0,12-5.4,12-12V712C898,705.4,892.6,700,886,700L886,700z"}})]),_vm._v(" "),_c('g',{attrs:{"id":"btn_canto3"},on:{"click":function($event){_vm.cambiar_canto(3)}}},[_c('path',{staticClass:"st0",attrs:{"d":"M70,529.5c-6.3,0-11.5-5.2-11.5-11.5V374c0-6.3,5.2-11.5,11.5-11.5h273c6.3,0,11.5,5.2,11.5,11.5v144\n    c0,6.3-5.2,11.5-11.5,11.5H70z"}}),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M343,363c6.1,0,11,4.9,11,11v144c0,6.1-4.9,11-11,11H70c-6.1,0-11-4.9-11-11V374c0-6.1,4.9-11,11-11H343\n     M343,362H70c-6.6,0-12,5.4-12,12v144c0,6.6,5.4,12,12,12h273c6.6,0,12-5.4,12-12V374C355,367.4,349.6,362,343,362L343,362z"}})]),_vm._v(" "),_c('g',{attrs:{"id":"btn_canto4"},on:{"click":function($event){_vm.cambiar_canto(4)}}},[_c('path',{staticClass:"st0",attrs:{"d":"M1201,529.5c-6.3,0-11.5-5.2-11.5-11.5V374c0-6.3,5.2-11.5,11.5-11.5h273c6.3,0,11.5,5.2,11.5,11.5v144\n    c0,6.3-5.2,11.5-11.5,11.5H1201z"}}),_vm._v(" "),_c('path',{staticClass:"st1",attrs:{"d":"M1474,363c6.1,0,11,4.9,11,11v144c0,6.1-4.9,11-11,11h-273c-6.1,0-11-4.9-11-11V374c0-6.1,4.9-11,11-11H1474\n     M1474,362h-273c-6.6,0-12,5.4-12,12v144c0,6.6,5.4,12,12,12h273c6.6,0,12-5.4,12-12V374C1486,367.4,1480.6,362,1474,362L1474,362z\n    "}})]),_vm._v(" "),_c('g',[_c('rect',{class:_vm.clasecanto1,attrs:{"x":"428","y":"298","width":"688","height":"11"}})]),_vm._v(" "),_c('g',[_c('rect',{staticClass:"st3",class:_vm.clasecanto2,attrs:{"x":"428","y":"604","width":"688","height":"11"}})]),_vm._v(" "),_c('rect',{class:_vm.clasecanto3,attrs:{"x":"428","y":"325","width":"11","height":"264"}}),_vm._v(" "),_c('rect',{class:_vm.clasecanto4,attrs:{"x":"1101","y":"325","width":"11","height":"264"}}),_vm._v(" "),_c('Canto3',{attrs:{"valor":_vm.getcanto3}}),_vm._v(" "),_c('Canto4',{attrs:{"valor":_vm.getcanto4}}),_vm._v(" "),_c('Canto1',{attrs:{"valor":_vm.getcanto1}}),_vm._v(" "),_c('Canto2',{attrs:{"valor":_vm.getcanto2}}),_vm._v(" "),_c('Giro',{attrs:{"valor":_vm.getgiro}}),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g'),_vm._v(" "),_c('g')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-xs-12",attrs:{"tabindex":"0"}},[_c('Actualizar'),_vm._v(" "),(_vm.alertaspendientes)?_c('div',[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('form',{attrs:{"id":"piezacorte"},on:{"submit":function($event){$event.preventDefault();return _vm.procesarpieza($event)}}},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6 col-xs-12 text-left"},[_c('label',{attrs:{"for":"placa"}},[_vm._v("Proyecto:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.descripcionproyecto),expression:"descripcionproyecto"}],staticClass:"form-control",class:_vm.clasedescripcion,attrs:{"type":"text","name":"descripcion"},domProps:{"value":(_vm.descripcionproyecto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.descripcionproyecto=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6 col-xs-12 text-left"},[_c('label',{attrs:{"for":"placa"}},[_vm._v("Placa:")]),_vm._v(" "),(_vm.deshabilitarplaca == 0)?_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.placa),expression:"placa"}],staticClass:"form-control",attrs:{"id":"placa","disabled":_vm.deshabilitarplaca == 1 ? true : false},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.placa=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0","selected":""}},[_vm._v("Seleccione")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("MDF Melamínico Blanco 18mm (2600x1830)")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("MDF Otro 2600 x 1830")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("MDF Otro 2750 x 1830")])])]):_c('div',[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text ",attrs:{"for":"lugar"}},[_vm._v("MDF "+_vm._s(this.$store.getters.largo_placa)+"x"+_vm._s(this.$store.getters.ancho_placa)+" "+_vm._s(this.$store.getters.mm_placa)+"mm Color:")])]),_vm._v(" "),(this.$store.getters.placa !== 1)?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.color_placa),expression:"color_placa"}],staticClass:"form-control ",class:_vm.clasecolor_placa,attrs:{"type":"text","maxlength":"100","autocomplete":"off","name":"color_placa","placeholder":"Escriba un Color"},domProps:{"value":(_vm.color_placa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.color_placa=$event.target.value}}})]):_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.color_placa),expression:"color_placa"}],staticClass:"form-control normal-input",attrs:{"type":"text","disabled":"","maxlength":"100","autocomplete":"off","name":"color_placa","placeholder":"Blanco","value":"Blanco"},domProps:{"value":(_vm.color_placa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.color_placa=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-6 col-xs-12 text-left"},[_c('label',{attrs:{"for":"canto"}},[_vm._v("Canto:")]),_vm._v(" "),(_vm.deshabilitacanto == 0)?_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.canto),expression:"canto"}],staticClass:"form-control",attrs:{"id":"canto"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.canto=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1","selected":""}},[_vm._v("ABS Blanco")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("ABS Otro")])])]):_c('div',[_c('div',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.color_canto),expression:"color_canto"}],staticClass:"form-control",class:_vm.clasecolor_canto,attrs:{"type":"text","maxlength":"100","autocomplete":"off","name":"color_canto","placeholder":"Escriba un Color"},domProps:{"value":(_vm.color_canto)},on:{"input":function($event){if($event.target.composing){ return; }_vm.color_canto=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('div',{staticClass:"alert alert-info alert-dismissible fade show",attrs:{"role":"alert"}},[_vm._v("\r\n\t\t  Todas las medidas deben ser ingresadas en Milimetros, el máximo disponible para Largo es "),_c('strong',[_vm._v(_vm._s(this.$store.getters.max_largo)+"mm")]),_vm._v(" y para el Ancho "),_c('strong',[_vm._v(_vm._s(this.$store.getters.max_ancho)+"mm")]),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4 col-xs-4 col-md-4"},[_c('label',{attrs:{"for":"cantidad"}},[_vm._v("Cantidad")]),_vm._v(" "),_c('div',{staticClass:"input-group grupo"},[_c('div',{staticClass:"input-group-prepend"},[_c('div',{staticClass:"input-group-text proximapieza"},[_vm._v(_vm._s(this.$store.getters.proximapieza))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cantidad),expression:"cantidad"}],staticClass:"form-control",class:_vm.clasecantidad,attrs:{"type":"number","id":"cantidad","name":"cantidad","maxlength":"2","placeholder":"#"},domProps:{"value":(_vm.cantidad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cantidad=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-4 col-xs-2 col-md-4"},[_c('label',{attrs:{"for":"largo"}},[_vm._v("Largo")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.largo),expression:"largo"}],staticClass:"form-control",class:_vm.claselargo,attrs:{"type":"number","id":"largo","placeholder":"(mm)"},domProps:{"value":(_vm.largo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.largo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-4 col-xs-2 col-md-4 form-group"},[_c('label',{attrs:{"for":"ancho"}},[_vm._v("Ancho")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ancho),expression:"ancho"}],staticClass:"form-control",class:_vm.claseancho,attrs:{"type":"number","id":"ancho","placeholder":"(mm)"},domProps:{"value":(_vm.ancho)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ancho=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-8 col-xs-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.detalle),expression:"detalle"}],staticClass:"form-control",attrs:{"type":"text","id":"detalle","placeholder":"Detalle"},domProps:{"value":(_vm.detalle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.detalle=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"anchosvg",attrs:{"id":"svg_completo44"}},[_c('SvgCantos')],1),_vm._v(" "),_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-8"},[_c('button',{staticClass:"btn btn-outline-danger pull-left",attrs:{"type":"button"},on:{"click":function($event){_vm.vaciarpieza()}}},[_vm._v("Vaciar")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[(_vm.piezavalida === 1)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v("+ Agregar")]):_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":""}},[_vm._v("+ Agregar")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive my-3"},[_c('table',{staticClass:"table table-striped table-sm",attrs:{"id":"tabla_piezas"}},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.listadepiezas(_vm.piezas)),function(value,key){return _c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(value.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.cantidad))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.largo)+"x"+_vm._s(value.ancho))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.detalle))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cantocompleto blanco",class:[_vm.colorescanto1(value.canto1), _vm.colorescanto2( value.canto2), _vm.colorescanto3(value.canto3), _vm.colorescanto4(value.canto4)]})]),_vm._v(" "),_c('td',[(value.giro == 0)?_c('div',[_vm._m(5,true)]):_c('div',[_vm._m(6,true)])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-outline-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.eliminarpieza(value.id)}}},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])])])}))])])]),_vm._v(" "),_c('div',{staticClass:"mb-5"},[_c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"col-8"},[_c('button',{staticClass:"btn btn-outline-danger pull-left",attrs:{"type":"button"},on:{"click":function($event){_vm.vaciarpedido()}}},[_vm._v("Borrar Pedido")])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[(_vm.pedidovalido)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"},on:{"click":function($event){$event.stopPropagation();_vm.enviarlista()}}},[_vm._v(" Enviar Pedido")]):_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":""}},[_vm._v("Enviar Pedido")])])])]),_vm._v(" "),(this.$store.getters.escarpintero === true)?_c('div',[_c('div',{staticClass:"col-12 text-left pl-2"},[_c('div',{staticClass:"row pb-2"},[_c('div',{staticClass:"col-md-2 col-6 text-right"},[_vm._v("\r\n\t  \t\t\t\tPlaca: \r\n\t  \t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"badge badge-light bg-secondary text-white labelmedidastotales pb-2 pt-2 pl-2 pr-2"},[_vm._v("\r\n\t  \t\t\t\t"+_vm._s(_vm.totalmts2))]),_vm._v(" \r\n\t  \t\t\t\tMts2\r\n\t  \t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"row pb-2"},[_c('div',{staticClass:"col-md-2 col-6 text-right"},[_vm._v("\r\n\t  \t\t\t\tCinta 0,45: \r\n\t  \t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"badge badge-light bg-secondary text-white labelmedidastotales pb-2 pt-2 pl-2 pr-2"},[_vm._v("\r\n\t  \t\t\t\t"+_vm._s(_vm.totalmtl045))]),_vm._v(" \r\n\t  \t\t\t\tMtl\r\n\t  \t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"row pb-2"},[_c('div',{staticClass:"col-md-2 col-6 text-right"},[_vm._v("\r\n\t  \t\t\t\tCinta 2mm: \r\n\t  \t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"badge badge-light bg-secondary text-white labelmedidastotales pb-2 pt-2 pl-2 pr-2"},[_vm._v("\r\n\t\t  \t\t\t"+_vm._s(_vm.totalmtl2))]),_vm._v(" \r\n\t\t  \t\t\tMtl\r\n\t  \t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"row pb-2"},[_c('div',{staticClass:"col-md-2 col-6 text-right"},[_vm._v("\r\n\t  \t\t\t\tTotal Corte: \r\n\t  \t\t\t")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-6"},[_c('span',{staticClass:"badge badge-light bg-secondary text-white labelmedidastotales pb-2 pt-2 pl-2 pr-2"},[_vm._v("\r\n\t\t  \t\t\t"+_vm._s(_vm.totalmtscorte))]),_vm._v(" \r\n\t\t  \t\t\tMtl\r\n\t  \t\t\t")])])])]):_vm._e(),_vm._v(" "),(this.$store.getters.escarpintero === false)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-xs-5 p-3 mb-2 bg-secondary text-white"},[_vm._v("\r\n\t  \t\tPlaca Mts2: "),_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(_vm.totalmts2))])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-xs-7"},[_vm._v("\r\n\t  \t\tUSD "),_c('span',{staticClass:"badge badge-info"},[_vm._v(_vm._s(_vm.totalmts2usd))]),_c('small',[_vm._v(" + IVA")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-xs-5 p-3 mb-2 bg-secondary text-white"},[_vm._v("\r\n\t  \t\tCinta 0,45mm: "),_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(_vm.totalmtl045))]),_vm._v(" mtl\r\n\t  \t")]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-xs-7"},[_vm._v("\r\n\t  \t\tUSD "),_c('span',{staticClass:"badge badge-info"},[_vm._v(_vm._s(_vm.totalmtl045usd))]),_c('small',[_vm._v(" + IVA")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-xs-5 p-3 mb-2 bg-secondary text-white"},[_vm._v("\r\n\t  \t\tCinta 2mm: "),_c('span',{staticClass:"badge badge-light"},[_vm._v(_vm._s(_vm.totalmtl2))]),_vm._v(" mtl\r\n\t  \t")]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-xs-7"},[_vm._v("\r\n\t  \t\tUSD "),_c('span',{staticClass:"badge badge-info"},[_vm._v(_vm._s(_vm.totalmtl2usd))]),_c('small',[_vm._v(" + IVA")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-xs-5 p-3 mb-2 bg-info text-white rounded"},[_vm._v("\r\n\t  \t\tTotal\r\n\t  \t")]),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-xs-7"},[_c('span',{staticClass:"border border-info rounded p-2"},[_vm._v(" USD "+_vm._s(_vm.totalcorte)),_c('small',[_vm._v(" + IVA")])])])]),_vm._v(" "),(this.$store.getters.escarpintero === false)?_c('div',{staticClass:"row mb-5"},[_vm._m(7)]):_vm._e()]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning alert-dismissible fade show",attrs:{"role":"alert"}},[_c('strong',[_vm._v("Perfecto!")]),_vm._v(" Ahora puedes generar tu Lista de Corte\r\n  "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-prepend"},[_c('label',{staticClass:"input-group-text",attrs:{"for":"lugar"}},[_vm._v("ABS otro Color:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 col-md-4 col-xs-4 text-right"},[_c('label',{attrs:{"for":"detalle"}},[_vm._v("Detalle")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Cant")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Medidas")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Detalles")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Cantos")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Giro")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Acción")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icono-giro"},[_c('i',{staticClass:"fa fa-lock",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icono-giro"},[_c('i',{staticClass:"fa fa-repeat",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-md-12 pt-2"},[_c('div',{staticClass:"alert alert-dark alert-dismissible fade show",attrs:{"role":"alert"}},[_vm._v("\r\n\t\t  Envío incluido en Montevideo en puerta de calle\r\n\t\t   "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_login_js__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623b840a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(136);
function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_623b840a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"clas":"container"}},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-7 background-tranparent padding_fondo"},[(this.$store.getters.url_empresa === 0 || this.$store.getters.url_empresa === 1)?_c('div',{staticClass:"text-left p-2"},[_c('h4',[_vm._v("Digitaliza desde el Celular tus listas de Corte para enviar a tu Barraca")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('img',{staticClass:"figure-img img-fluid p-1",staticStyle:{"max-height":"220px"},attrs:{"src":"https://muebles.uy/muebles-cdn/art-img/playdeplak.png"},on:{"click":function($event){_vm.vervideo()}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"p-2 btn bg-primary text-white",attrs:{"type":"button"},on:{"click":function($event){_vm.masinfo()}}},[_vm._v("Quiero conocer más...")])]):_vm._e(),_vm._v(" "),(this.$store.getters.url_empresa === 141 )?_c('div',{staticClass:"text-left p-2"},[_c('h1',{staticClass:"display-4"},[_vm._v("Maderas Gabycar")]),_vm._v(" "),_c('h4',[_vm._v("Digitaliza desde el Celular tus listas de Corte y envía")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('img',{staticClass:"figure-img img-fluid p-1",staticStyle:{"max-height":"220px"},attrs:{"src":"https://muebles.uy/muebles-cdn/art-img/playdeplak.png"},on:{"click":function($event){_vm.vervideo()}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"p-2 btn bg-primary text-white",attrs:{"type":"button"},on:{"click":function($event){_vm.masinfo()}}},[_vm._v("Quiero conocer más...")])]):_vm._e(),_vm._v(" "),(this.$store.getters.url_empresa === 151 )?_c('div',{staticClass:"text-left p-2"},[_c('h1',{staticClass:"display-4"},[_vm._v("Barraca Paraná")]),_vm._v(" "),_c('h4',[_vm._v("Digitaliza desde el Celular tus listas de Corte y envía")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('img',{staticClass:"figure-img img-fluid p-1",staticStyle:{"max-height":"220px"},attrs:{"src":"https://muebles.uy/muebles-cdn/art-img/playdeplak.png"},on:{"click":function($event){_vm.vervideo()}}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"p-2 btn bg-primary text-white",attrs:{"type":"button"},on:{"click":function($event){_vm.masinfo()}}},[_vm._v("Quiero conocer más...")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-5 fondogris"},[_c('div',{staticClass:"row",attrs:{"id":"iniciarsesion"}},[_c('form',{staticClass:"form-signin"},[_c('h3',{staticClass:"h3 mb-3 font-weight-normal"},[_vm._v("Iniciar Sesión")]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputEmail"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mail),expression:"mail"}],staticClass:"form-control",attrs:{"id":"inputEmail","placeholder":"09X-111222","required":"","autofocus":"","type":"text"},domProps:{"value":(_vm.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mail=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Contraseña")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.pass),expression:"pass"}],staticClass:"form-control",attrs:{"id":"inputPassword","placeholder":"Contraseña","required":"","type":"password"},domProps:{"value":(_vm.pass)},on:{"input":function($event){if($event.target.composing){ return; }_vm.pass=$event.target.value}}}),_vm._v(" "),(_vm.errores.length)?_c('div',[_c('b',[_vm._v("Verifique lo(s) siguiente(s) errores:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errores),function(error){return _c('li',[_vm._v(_vm._s(error))])}))]):_vm._e(),_vm._v(" "),(this.cargandologin === '')?_c('div',[_c('button',{staticClass:"btn btn-outline-primary btn-block",attrs:{"type":"submit"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.logindeplaka($event)}}},[_vm._v("Iniciar")]),_vm._v(" "),_c('p',{staticClass:"mt-2 mb-2",on:{"click":function($event){_vm.recuperarclave()}}},[_vm._v("Recuperar Clave")])]):_c('div',[_vm._v("\n                "+_vm._s(this.cargandologin)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row "},[_c('form',{staticClass:"form-signin fondoregistro"},[_c('h1',{staticClass:"h3 mb-3 font-weight-normal"},[_vm._v("Quiero Registrarme")]),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputregnombre"}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regnombre),expression:"regnombre"}],staticClass:"form-control",attrs:{"id":"inputregnombre","placeholder":"Nombre","required":"","type":"text"},domProps:{"value":(_vm.regnombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.regnombre=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputregcelular"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regcelular),expression:"regcelular"}],staticClass:"form-control",attrs:{"id":"inputregcelular","placeholder":"Celular 09X-111222","required":"","type":"text"},domProps:{"value":(_vm.regcelular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.regcelular=$event.target.value}}}),_vm._v("\n      "+_vm._s(this.cargando)+"\n      "),_c('div',{staticClass:"row pl-1 pr-1"},[(_vm.avisos.length)?_c('p',[_c('b',[_vm._v("Verifique lo(s) siguiente(s) errores:")])]):_vm._e(),_vm._l((_vm.avisos),function(error){return _c('div',{staticClass:"alert alert-warning alert-dismissible fade show",attrs:{"role":"alert"}},[_c('strong',[_vm._v(_vm._s(error))])])}),_vm._v(" "),_c('p')],2),_vm._v(" "),(_vm.cargando === '')?_c('button',{staticClass:"btn btn-dark btn-block",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.registrodeplak($event)}}},[_vm._v("Registrarme")]):_vm._e()])])])])]),_vm._v(" "),_vm._m(3)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('span',[_vm._v("Digitaliza tus listas en cualquier lugar que estés "),_c('small',[_vm._v("(incluso sin datos)")])])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Las piezas no se pierden al cerrar la web ")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Envía el archivo a tu Barraca de siempre ")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Digitaliza la lista y envía cuando quieras")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Guarda en la Biblioteca las listas que siempre usas y vuelve a reusarlas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('span',[_vm._v("Digitaliza tus listas en cualquier lugar que estés "),_c('small',[_vm._v("(incluso sin datos)")])])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Las piezas no se pierden al cerrar la web ")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Envía el archivo a tu Barraca de siempre ")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Digitaliza la lista y envía cuando quieras")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Guarda en la Biblioteca las listas que siempre usas y vuelve a reusarlas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('span',[_vm._v("Digitaliza tus listas en cualquier lugar que estés "),_c('small',[_vm._v("(incluso sin datos)")])])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Las piezas no se pierden al cerrar la web ")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Envía el archivo a tu Barraca de siempre ")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Digitaliza la lista y envía cuando quieras")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Guarda en la Biblioteca las listas que siempre usas y vuelve a reusarlas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"exampleModal","tabindex":"-1","role":"dialog","aria-labelledby":"exampleModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('iframe',{attrs:{"width":"350","height":"300","src":"https://www.youtube.com/embed/nlUM8FQAZIo?rel=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_pedidos_js__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4f4cfd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pedidos_vue__ = __webpack_require__(139);
function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_pedidos_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4f4cfd4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pedidos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"pedidos"}},[_c('Actualizar'),_vm._v(" "),_c('div',{},[_c('h3',[_vm._v("Enviados")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"table-responsive my-3"},[_c('table',{staticClass:"table table-striped table-sm",attrs:{"id":"tabla_piezas"}},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.listapedidos),function(value,key){return _c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(value.id)+" "),_c('button',{staticClass:"btn btn-outline-info btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.verpedido(value.id)}}},[_vm._v(" Ver ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.fecha))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.descripcion))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.cantidad))]),_vm._v(" "),_c('td',[(value.estado == 2)?_c('button',{staticClass:"btn btn-outline-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.marcarpedido(value.id, key)}}},[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(value.estado == 3)?_c('button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-check-circle",attrs:{"aria-hidden":"true"}})]):_vm._e()])])}))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.volveratras()}}},[_c('i',{staticClass:"fa fa-plus",attrs:{"aria-hidden":"true"}}),_vm._v("\r\n Nuevo Pedido")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Fecha")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Descripcion")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Piezas")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Marcar Recibido")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_pedido_js__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_253f2f83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pedido_vue__ = __webpack_require__(142);
function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_pedido_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_253f2f83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pedido_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cargacompleta === true)?_c('div',{staticClass:"col-md-12 col-xs-12",attrs:{"id":"pedido"}},[_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('div',{staticClass:"row pl-2"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\r\n\t\t    Pedido # "+_vm._s(_vm.pedido.id)+"\r\n\t\t  ")]),_vm._v(" "),_c('div',{staticClass:"card-body text-justify"},[_c('h5',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.pedido.descripcion))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Placa: "+_vm._s(_vm.nombrematerial)+" "+_vm._s(_vm.colorplaca))]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Canto: ABS "+_vm._s(_vm.colorcanto))]),_vm._v(" "),(_vm.lugarenvio !== false)?_c('div',[_c('p',{staticClass:"card-text"},[_vm._v("Enviado a: "+_vm._s(_vm.lugarenvio))])]):_vm._e(),_vm._v(" "),(_vm.fecha_recibido !== false)?_c('div',[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.fecha_recibido)+"\t")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(this.$store.getters.escarpintero === true)?_c('div',[_c('p',{staticClass:"card-text"},[_vm._v("Placa: "),_c('span',{staticClass:"badge badge-light bg-secondary text-white labelmedidastotales pb-2 pt-2 pl-2 pr-2"},[_vm._v("\r\n\t\t\t  \t\t\t\t"+_vm._s(_vm.totalmts2))]),_vm._v("  Mts2")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Cinta 0,45: "),_c('span',{staticClass:"badge badge-light bg-secondary text-white labelmedidastotales pb-2 pt-2 pl-2 pr-2"},[_vm._v("\r\n\t\t\t  \t\t\t\t"+_vm._s(_vm.totalmtl045))]),_vm._v("  Mtl")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Cinta 2mm: "),_c('span',{staticClass:"badge badge-light bg-secondary text-white labelmedidastotales pb-2 pt-2 pl-2 pr-2"},[_vm._v("\r\n\t\t\t  \t\t\t\t"+_vm._s(_vm.totalmtl2))]),_vm._v("  Mtl")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("Total corte: "),_c('span',{staticClass:"badge badge-light bg-secondary text-white labelmedidastotales pb-2 pt-2 pl-2 pr-2"},[_vm._v("\r\n\t\t\t  \t\t\t\t"+_vm._s(_vm.totalcorte))]),_vm._v("  Mtl")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.pedido.archivo > 0)?_c('div',[_c('button',{staticClass:"btn btn-outline-secundary btn-sm",on:{"click":function($event){_vm.descargararchivo()}}},[_c('i',{staticClass:"fa fa-download",attrs:{"aria-hidden":"true"}}),_vm._v("\r\n Descargar Archivo")])]):_vm._e(),_vm._v(" "),(_vm.pedido.estado !== 8 && this.$store.getters.accesodeplakcompleto === true)?_c('div',[_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-info btn-sm",on:{"click":function($event){_vm.enviarabiblioteca()}}},[_c('i',{staticClass:"fa fa-home",attrs:{"aria-hidden":"true"}}),_vm._v(" Enviar a Biblioteca ")])]):_vm._e(),_vm._v(" "),_c('div',[_c('hr'),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"btn btn-outline-info btn-sm",on:{"click":function($event){_vm.enviarapedido()}}},[_c('i',{staticClass:"fa fa-external-link",attrs:{"aria-hidden":"true"}}),_vm._v(" Reenviar Pedido")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row",attrs:{"id":"listapiezas"}},[_c('div',{staticClass:"table-responsive my-3"},[_c('table',{staticClass:"table table-striped table-sm",attrs:{"id":"tabla_piezas"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.listapiezas(_vm.lineas)),function(value,key){return _c('tr',[_c('th',{attrs:{"scope":"row"}},[_vm._v(_vm._s(value.nro))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.cantidad))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.largo)+"x"+_vm._s(value.ancho))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value.descripcion))]),_vm._v(" "),_c('td',[_c('div',{staticClass:"cantocompleto blanco",class:[_vm.colorescanto1(value.canto1), _vm.colorescanto2( value.canto2), _vm.colorescanto3(value.canto3), _vm.colorescanto4(value.canto4)]})])])}))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.volverpedidos()}}},[_c('i',{staticClass:"fa fa-arrow-left",attrs:{"aria-hidden":"true"}}),_vm._v(" Volver al listado")])])])]):_c('div',[_vm._v("\r\n\tCargando...\r\n")])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"btn btn-success btn-sm"},[_c('i',{staticClass:"fa fa-check-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" Confirmado ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-secundary btn-sm",attrs:{"onclick":"window.print();"}},[_c('i',{staticClass:"fa fa-print",attrs:{"aria-hidden":"true"}}),_vm._v(" Imprimir")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("#")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Cant")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Medidas")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Detalles")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("Cantos")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_registro_js__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f099b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registro_vue__ = __webpack_require__(148);
function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_registro_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39f099b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_registroproveedores_js__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eae2911_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registroproveedores_vue__ = __webpack_require__(147);
function injectStyle (ssrContext) {
  __webpack_require__(146)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_js_registroproveedores_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eae2911_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registroproveedores_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-md-10 col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",attrs:{"id":"inputnombreproveedor","placeholder":"Nombre","required":"","type":"text"},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-signin fondogris"},[_c('h1',{staticClass:"h3 mb-3 font-weight-normal"},[_vm._v("Registrarme")]),_vm._v(" "),_c('label',{attrs:{"for":"inputnombre"}},[_vm._v("Nombre")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.nombre),expression:"nombre"}],staticClass:"form-control",attrs:{"id":"inputnombre","placeholder":"Nombre","required":"","autofocus":"","type":"text"},domProps:{"value":(_vm.nombre)},on:{"input":function($event){if($event.target.composing){ return; }_vm.nombre=$event.target.value}}}),_vm._v(" "),_c('label',{attrs:{"for":"inputcelular"}},[_vm._v("Celular")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.celular),expression:"celular"}],staticClass:"form-control",attrs:{"id":"inputcelular","placeholder":"09X-111222","required":"","type":"text"},domProps:{"value":(_vm.celular)},on:{"input":function($event){if($event.target.composing){ return; }_vm.celular=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row pl-1 pr-1"},[(_vm.avisos.length)?_c('p',[_c('b',[_vm._v("Verifique lo(s) siguiente(s) errores:")])]):_vm._e(),_vm._l((_vm.avisos),function(error){return _c('div',{staticClass:"alert alert-warning alert-dismissible fade show",attrs:{"role":"alert"}},[_c('strong',[_vm._v(_vm._s(error))])])}),_vm._v(" "),_c('p')],2),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.registrodeplak($event)}}},[_vm._v("Registarme")]),_vm._v(" "),_c('p',{on:{"click":function($event){_vm.iralogin()}}},[_vm._v("Ya tengo cuenta")]),_vm._v(" "),_c('p',{staticClass:"mt-5 mb-3 text-muted"},[_vm._v("© 2018 DEPLAK")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_js__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__placas_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__proveedores_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);








__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    descripcion: '',
    cantidad: 0,
    canto1: 0,
    canto2: 0,
    canto3: 0,
    canto4: 0,
    largo: 0,
    ancho: 0,
    detalle: '',
    giro: 1,
    placa: 0,
    color_placa: '',
    color_canto: '',
    canto: 1,
    count: 0,
    piezas: __WEBPACK_IMPORTED_MODULE_4__data_js__["a" /* piezas */],
    placas: __WEBPACK_IMPORTED_MODULE_5__placas_js__["a" /* placas */],
    proveedores: __WEBPACK_IMPORTED_MODULE_6__proveedores_js__["a" /* proveedores */],
    cred: [],
    urlida: '',
    totalmt2: 0,
    totalmt2usd: 0,
    pedidos: [],
    categorias: [],
    max_largo: 2585,
    max_ancho: 1815,
    empresareferida: 0
  },
  getters: {
    islogin: function islogin(state, getters) {
      if (getters.idactual > 0) {
        return true;
      } else {
        return false;
      }
    },
    idactual: function idactual(state) {
      return state.cred[4665];
    },
    credactual: function credactual(state) {
      return state.cred[5235];
    },
    url_empresa: function url_empresa() {
      var path = window.location.href;
      if (/(gabycar)/.test(path)) {
        return 141;
      } else if (/(parana)/.test(path)) {
        return 151;
      } else {
        return 1;
      }
    },

    empresareferida: function empresareferida(state) {
      return parseInt(state.empresareferida);
    },
    datosempresareferida: function datosempresareferida(state, getters) {
      var empresa = getters.empresareferida;
      var filtro = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(state.proveedores, ['id', empresa]);
      return filtro;
    },
    datosproveedor: function datosproveedor(state, getters) {
      return function (nro) {
        var filtro = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(state.proveedores, ['id', nro]);
        return filtro[0];
      };
    },
    accesodeplakcompleto: function accesodeplakcompleto(state, getters) {
      if (getters.empresareferida === '1' || getters.empresareferida === 1) {
        return true;
      }
      return false;
    },
    zonausuario: function zonausuario(state) {
      if (state.cred[7867] === undefined) {
        return false;
      } else {
        return state.cred[7867];
      }
    },
    mailusuario: function mailusuario(state) {
      if (state.cred[7866] === undefined) {
        return false;
      } else {
        return state.cred[7866];
      }
    },
    pedirdatos: function pedirdatos(state, getters) {
      if (getters.mailusuario === '' || getters.zonausuario === '') {
        return true;
      } else {
        return false;
      }
    },

    escarpintero: function escarpintero(state) {
      if (__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.size(state.cred[2006]) >= 1) {
        return true;
      } else {
        return false;
      }
    },
    nombreusuario: function nombreusuario(state) {
      return state.cred[7865];
    },
    urlsalida: function urlsalida(state) {
      return state.urlida;
    },
    cal_totalmt2: function cal_totalmt2(state, getters) {
      return function (value) {
        var total = 0;
        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(value, function (value, key) {
          total = total + value.cantidad.valueOf() * (value.ancho.valueOf() * value.largo.valueOf()) / 1000000;
        });
        return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(total, 2);
      };
    },
    totalmt2: function totalmt2(state, getters) {
      var total = getters.cal_totalmt2(getters.piezas);
      return total;
    },
    totalmt2usd: function totalmt2usd(state, getters) {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(getters.totalmt2.valueOf() * 20, 2);
    },
    cal_totalmtl045: function cal_totalmtl045(state, getters) {
      return function (value) {
        var total = 0;
        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(value, function (value, key) {
          if (value.canto1 === 1) {
            total = total + value.cantidad.valueOf() * value.largo.valueOf() / 1000;
          }
          if (value.canto2 === 1) {
            total = total + value.cantidad.valueOf() * value.largo.valueOf() / 1000;
          }
          if (value.canto3 === 1) {
            total = total + value.cantidad.valueOf() * value.ancho.valueOf() / 1000;
          }
          if (value.canto4 === 1) {
            total = total + value.cantidad.valueOf() * value.ancho.valueOf() / 1000;
          }
        });
        return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(total, 2);
      };
    },
    totalmtl045: function totalmtl045(state, getters) {
      var total = getters.cal_totalmtl045(getters.piezas);
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(total, 2);
    },
    totalmtl045usd: function totalmtl045usd(state, getters) {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(getters.totalmtl045.valueOf() * 3, 2);
    },
    cal_totalmtl2: function cal_totalmtl2(state, getters) {
      return function (value) {
        var total = 0;
        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(value, function (value, key) {
          if (value.canto1 === 2) {
            total = total + value.cantidad.valueOf() * value.largo.valueOf() / 1000;
          }
          if (value.canto2 === 2) {
            total = total + value.cantidad.valueOf() * value.largo.valueOf() / 1000;
          }
          if (value.canto3 === 2) {
            total = total + value.cantidad.valueOf() * value.ancho.valueOf() / 1000;
          }
          if (value.canto4 === 2) {
            total = total + value.cantidad.valueOf() * value.ancho.valueOf() / 1000;
          }
        });
        return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(total, 2);
      };
    },
    totalmtl2: function totalmtl2(state, getters) {
      var total = getters.cal_totalmtl2(getters.piezas);
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(total, 2);
    },
    totalmtl2usd: function totalmtl2usd(state, getters) {
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(getters.totalmtl2.valueOf() * 4, 2);
    },
    cal_totalmtcortes: function cal_totalmtcortes(state, getters) {
      return function (value) {
        var total = 0;
        __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(value, function (value, key) {
          total = total + value.cantidad.valueOf() * (value.ancho.valueOf() * 2 + value.largo.valueOf() * 2) / 1000;
        });
        return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(total, 2);
      };
    },
    totalmtscorte: function totalmtscorte(state, getters) {
      var total = getters.cal_totalmtcortes(getters.piezas);
      return __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.round(total, 2);
    },
    estadocanto1: function estadocanto1(state) {
      return state.canto1.valueOf();
    },
    estadocanto2: function estadocanto2(state) {
      return state.canto2.valueOf();
    },
    estadocanto3: function estadocanto3(state) {
      return state.canto3.valueOf();
    },
    estadocanto4: function estadocanto4(state) {
      return state.canto4.valueOf();
    },
    giro: function giro(state) {
      return state.giro.valueOf();
    },
    descripcion: function descripcion(state) {
      return state.descripcion;
    },
    cantidad: function cantidad(state) {
      return state.cantidad.valueOf();
    },
    largo: function largo(state) {
      return state.largo.valueOf();
    },
    ancho: function ancho(state) {
      return state.ancho.valueOf();
    },
    detalle: function detalle(state) {
      return state.detalle;
    },
    piezavalida: function piezavalida(state, getters) {
      if (getters.placa.valueOf() >= 1 && getters.largo >= 50 && getters.largo <= getters.max_largo && getters.ancho >= 50 && getters.ancho <= getters.max_ancho && getters.cantidad > 0) {
        return 1;
      } else {
        return 0;
      }
    },
    placa: function placa(state) {
      return state.placa;
    },
    largo_placa: function largo_placa(state, getters) {
      if (getters.placa !== 0) {
        return __WEBPACK_IMPORTED_MODULE_5__placas_js__["a" /* placas */][getters.placa].largo;
      }
    },
    ancho_placa: function ancho_placa(state, getters) {
      if (getters.placa !== 0) {
        return __WEBPACK_IMPORTED_MODULE_5__placas_js__["a" /* placas */][getters.placa].ancho;
      }
    },
    mm_placa: function mm_placa(state, getters) {
      if (getters.placa !== 0) {
        return __WEBPACK_IMPORTED_MODULE_5__placas_js__["a" /* placas */][getters.placa].mm;
      }
    },
    color_placa: function color_placa(state) {
      return state.color_placa;
    },
    color_canto: function color_canto(state) {
      return state.color_canto;
    },
    canto: function canto(state) {
      return state.canto;
    },
    max_largo: function max_largo(state) {
      return state.max_largo;
    },
    max_ancho: function max_ancho(state) {
      return state.max_ancho;
    },
    piezas: function piezas(state) {
      return state.piezas;
    },
    cantidadpiezas: function cantidadpiezas(state) {
      return state.piezas.length;
    },
    proximapieza: function proximapieza(state) {
      return state.piezas.length + 1;
    },
    descripcionproyecto: function descripcionproyecto(state) {
      return state.descripcion;
    },
    pedidos: function pedidos(state) {
      return state.pedidos;
    },
    categorias: function categorias(state) {
      return state.categorias;
    }
  },
  mutations: {
    CAMBIAR_CANTO_MUTATION: function CAMBIAR_CANTO_MUTATION(state, data) {
      if (data === 1) {
        if (this.getters.estadocanto1 === 2) {
          state.canto1 = 0;
        } else {
          state.canto1++;
        }
      }
      if (data === 2) {
        if (this.getters.estadocanto2 === 2) {
          state.canto2 = 0;
        } else {
          state.canto2++;
        }
      }
      if (data === 3) {
        if (this.getters.estadocanto3 === 2) {
          state.canto3 = 0;
        } else {
          state.canto3++;
        }
      }
      if (data === 4) {
        if (this.getters.estadocanto4 === 2) {
          state.canto4 = 0;
        } else {
          state.canto4++;
        }
      }
    },
    CAMBIAR_DESCRIPCION_MUTATION: function CAMBIAR_DESCRIPCION_MUTATION(state, data) {
      state.descripcion = data;
    },
    CAMBIAR_CANTIDAD_MUTATION: function CAMBIAR_CANTIDAD_MUTATION(state, data) {
      state.cantidad = data;
    },
    CAMBIAR_LARGO_MUTATION: function CAMBIAR_LARGO_MUTATION(state, data) {
      state.largo = data;
    },
    CAMBIAR_ANCHO_MUTATION: function CAMBIAR_ANCHO_MUTATION(state, data) {
      state.ancho = data;
    },
    CAMBIAR_DETALLE_MUTATION: function CAMBIAR_DETALLE_MUTATION(state, data) {
      state.detalle = data;
    },
    CAMBIAR_GIRO_MUTATION: function CAMBIAR_GIRO_MUTATION(state, data) {
      state.giro = data;
    },
    CAMBIAR_COLOR_MUTATION: function CAMBIAR_COLOR_MUTATION(state, data) {
      state.color_placa = data;
    },
    CAMBIAR_COLOR_CANTO_MUTATION: function CAMBIAR_COLOR_CANTO_MUTATION(state, data) {
      state.color_canto = data;
    },
    CAMBIAR_PLACA_MUTATION: function CAMBIAR_PLACA_MUTATION(state, data) {
      state.placa = data;
    },
    CAMBIAR_CANTOT_MUTATION: function CAMBIAR_CANTOT_MUTATION(state, data) {
      state.canto = data;
    },
    VACIAR_PEDIDO_MUTATION: function VACIAR_PEDIDO_MUTATION(state, data) {
      this.state.descripcion = '';
      this.state.placa = 0;
      this.state.canto = 1;
      this.state.giro = 1;
      this.state.color_placa = '';
      this.state.color_canto = '';
      this.state.max_largo = state.placas[1].max_largo;
      this.state.max_ancho = state.placas[1].max_ancho;
      this.state.piezas = [];
    },
    VACIAR_PIEZA_MUTATION: function VACIAR_PIEZA_MUTATION(state, data) {
      state.cantidad = '';
      state.canto1 = 0;
      state.canto2 = 0;
      state.canto3 = 0;
      state.canto4 = 0;
      state.ancho = '';
      state.largo = '';
      if (state.placa === 1) {
        state.giro = 1;
      } else {
        state.giro = 0;
      }
    },
    BLOQUEAR_ROTACION_MUTATION: function BLOQUEAR_ROTACION_MUTATION(state, data) {
      state.giro = data;
    },
    PROCESAR_PIEZA_MUTATION: function PROCESAR_PIEZA_MUTATION(state) {
      var actuales = 1;
      if (this.getters.cantidadpiezas >= 1) {
        actuales = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.maxBy(this.getters.piezas, function (o) {
          return o.id;
        });
        actuales = actuales['id'];
        actuales = ++actuales;
      }
      var nuevapieza = { id: actuales, cantidad: this.getters.cantidad, largo: this.getters.largo, ancho: this.getters.ancho, canto1: this.getters.estadocanto1, canto2: this.getters.estadocanto2, canto3: this.getters.estadocanto3, canto4: this.getters.estadocanto4, giro: this.getters.giro, detalle: this.getters.detalle };
      state.piezas.push(nuevapieza);
    },
    AGREGAR_PIEZA_DE_BIBLIOTECA_MUTATION: function AGREGAR_PIEZA_DE_BIBLIOTECA_MUTATION(state, data) {
      state.piezas.push(data);
    },
    ELIMINAR_PIEZA_MUTATION: function ELIMINAR_PIEZA_MUTATION(state, index) {
      var piezas = this.getters.piezas;
      var nuevas = piezas.filter(function (i) {
        return i.id !== index;
      });
      this.state.piezas = nuevas;
    },
    GUARDAR_PEDIDO_MUTATION: function GUARDAR_PEDIDO_MUTATION(state) {
      console.log('guardo en local');
    },
    initialiseStore: function initialiseStore(state) {
      if (localStorage.getItem('store')) {
        // Replace the state object with the stored item
        this.replaceState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state, JSON.parse(localStorage.getItem('store'))));
      }
    },

    SET_CREDENCIAL_MUTATION: function SET_CREDENCIAL_MUTATION(state, data) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.state.cred, data[0], data[1]);
    },
    SET_EMPRESAREFERIDA_MUTATION: function SET_EMPRESAREFERIDA_MUTATION(state, data) {
      this.state.empresareferida = data;
    },
    SET_URL_VER_MUTATION: function SET_URL_VER_MUTATION(state, data) {
      this.state.urlida = data;
    },
    SET_PEDIDOS_MUTATION: function SET_PEDIDOS_MUTATION(state, data) {
      this.state.pedidos = data;
    },
    SET_CATEGORIAS_MUTATION: function SET_CATEGORIAS_MUTATION(state, data) {
      this.state.categorias = data;
    },
    MARCAR_PEDIDO_MUTATION: function MARCAR_PEDIDO_MUTATION(state, data) {
      var actual = __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.filter(this.state.pedidos, function (o) {
        return o.id === data;
      });
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(actual, 'estado', 3);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.state.pedidos, data, actual);
    },
    CAMBIAR_MAX_LARGO_MUTATION: function CAMBIAR_MAX_LARGO_MUTATION(state, data) {
      this.state.max_largo = data;
    },
    CAMBIAR_MAX_ANCHO_MUTATION: function CAMBIAR_MAX_ANCHO_MUTATION(state, data) {
      this.state.max_ancho = data;
    }
  },
  actions: {
    REINICIAR_PEDIDO: function REINICIAR_PEDIDO(context) {
      context.commit('VACIAR_PEDIDO_MUTATION');
    },
    CAMBIAR_DESCRIPCION: function CAMBIAR_DESCRIPCION(context, data) {
      context.commit('CAMBIAR_DESCRIPCION_MUTATION', data);
    },
    CAMBIAR_CANTO: function CAMBIAR_CANTO(context, data) {
      context.commit('CAMBIAR_CANTO_MUTATION', data);
    },
    CAMBIAR_CANTIDAD: function CAMBIAR_CANTIDAD(context, data) {
      context.commit('CAMBIAR_CANTIDAD_MUTATION', data);
    },
    CAMBIAR_LARGO: function CAMBIAR_LARGO(context, data) {
      context.commit('CAMBIAR_LARGO_MUTATION', data);
    },
    CAMBIAR_ANCHO: function CAMBIAR_ANCHO(context, data) {
      context.commit('CAMBIAR_ANCHO_MUTATION', data);
    },
    CAMBIAR_DETALLE: function CAMBIAR_DETALLE(context, data) {
      context.commit('CAMBIAR_DETALLE_MUTATION', data);
    },
    CAMBIAR_GIRO: function CAMBIAR_GIRO(context, data) {
      context.commit('CAMBIAR_GIRO_MUTATION', data);
    },
    CAMBIAR_COLOR: function CAMBIAR_COLOR(context, data) {
      context.commit('CAMBIAR_COLOR_MUTATION', data);
    },
    CAMBIAR_COLOR_CANTO: function CAMBIAR_COLOR_CANTO(context, data) {
      context.commit('CAMBIAR_COLOR_CANTO_MUTATION', data);
    },
    CAMBIAR_PLACA: function CAMBIAR_PLACA(context, data) {
      context.commit('CAMBIAR_PLACA_MUTATION', data);
      if (data !== 0) {
        context.commit('CAMBIAR_MAX_LARGO_MUTATION', __WEBPACK_IMPORTED_MODULE_5__placas_js__["a" /* placas */][data].max_largo);
        context.commit('CAMBIAR_MAX_ANCHO_MUTATION', __WEBPACK_IMPORTED_MODULE_5__placas_js__["a" /* placas */][data].max_ancho);
      } else {
        context.commit('CAMBIAR_MAX_LARGO_MUTATION', __WEBPACK_IMPORTED_MODULE_5__placas_js__["a" /* placas */][1].max_largo);
        context.commit('CAMBIAR_MAX_ANCHO_MUTATION', __WEBPACK_IMPORTED_MODULE_5__placas_js__["a" /* placas */][1].max_ancho);
      }
      if (data > 1) {
        context.commit('BLOQUEAR_ROTACION_MUTATION', 0);
      } else {
        context.commit('BLOQUEAR_ROTACION_MUTATION', 1);
        context.commit('CAMBIAR_COLOR_MUTATION', 'Blanco');
      }
    },
    CAMBIAR_CANTOT: function CAMBIAR_CANTOT(context, data) {
      context.commit('CAMBIAR_CANTOT_MUTATION', data);
    },
    VACIAR_PEDIDO: function VACIAR_PEDIDO(context, data) {
      context.commit('VACIAR_PIEZA_MUTATION');
      context.commit('VACIAR_PEDIDO_MUTATION');
      context.commit('BLOQUEAR_ROTACION_MUTATION', 1);
    },
    VACIAR_PIEZA: function VACIAR_PIEZA(context, data) {
      context.commit('VACIAR_PIEZA_MUTATION');
    },
    PROCESAR_PIEZA: function PROCESAR_PIEZA(context, data) {
      if (this.getters.piezavalida === 1) {
        context.commit('PROCESAR_PIEZA_MUTATION');
        context.commit('VACIAR_PIEZA_MUTATION');
      }
    },
    AGREGAR_PIEZA_DE_BIBLIOTECA: function AGREGAR_PIEZA_DE_BIBLIOTECA(context, data) {
      console.log(data);
      context.commit('AGREGAR_PIEZA_DE_BIBLIOTECA_MUTATION', data);
    },
    ELIMINAR_PIEZA: function ELIMINAR_PIEZA(context, data) {
      context.commit('ELIMINAR_PIEZA_MUTATION', data);
    },
    PROCESAR_PEDIDO: function PROCESAR_PEDIDO(context, data) {
      context.commit('GUARDAR_PEDIDO_MUTATION');
    },
    SET_CREDENCIALES: function SET_CREDENCIALES(context, data) {
      __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.forEach(data, function (value, key) {
        var data = [];
        data[0] = key;
        data[1] = value;
        context.commit('SET_CREDENCIAL_MUTATION', data);
      });
    },
    SET_EMPRESAREFERIDA: function SET_EMPRESAREFERIDA(context, data) {
      context.commit('SET_EMPRESAREFERIDA_MUTATION', data);
    },
    SET_URL_VER: function SET_URL_VER(context, data) {
      context.commit('SET_URL_VER_MUTATION', data);
    },
    SET_PEDIDOS: function SET_PEDIDOS(context, data) {
      context.commit('SET_PEDIDOS_MUTATION', data);
    },
    SET_CATEGORIAS: function SET_CATEGORIAS(context, data) {
      context.commit('SET_CATEGORIAS_MUTATION', data);
    },
    MARCAR_PEDIDO: function MARCAR_PEDIDO(context, data) {
      context.commit('MARCAR_PEDIDO_MUTATION', data);
    }
  },
  modules: {},
  strict: debug
});
store.subscribe(function (mutation, state) {
  // Store the state object as a JSON string
  localStorage.setItem('store', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state));
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return piezas; });
var piezas = [];

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placas; });
var placas = { 1: { 'max_largo': 2585, 'max_ancho': 1815, 'largo': 2600, 'ancho': 1830, 'mm': 18 }, 2: { 'max_largo': 2585, 'max_ancho': 1815, 'largo': 2600, 'ancho': 1830, 'mm': 18 }, 3: { 'max_largo': 2750, 'max_ancho': 1830, 'largo': 2750, 'ancho': 1830, 'mm': 18 } };

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return proveedores; });
var proveedores = { 141: { 'id': 141, 'nombre': 'Gabycar Cortes', 'mail': 'servicios@gabycar.com', 'zona': 'Domingo Aramburú & José L. Terra', 'tel': 1234 }, 151: { 'id': 151, 'nombre': 'Barraca Parana', 'mail': 'bruno.battistin@barracaparana.com', 'zona': 'Calle Democracia 2350', 'tel': 22277952 }, 3419: { 'id': 3419, 'nombre': 'Roberto Ibarra', 'mail': 'ibarra@muebles.uy', 'zona': 'Bulevar Artigas 4549', 'tel': 22027288 }, 4502: { 'id': 4502, 'nombre': 'Turquia3377', 'mail': 'turquia3377@gmail.com', 'zona': 'Turquia 3377', 'tel': 23146590 } };

/***/ })
],[57]);


// WEBPACK FOOTER //
// static/js/app.505a0d71e4cf5acd0420.js